/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateOptionalTime: any;
  DateOptionalTimeRange: any;
  DateTime: any;
  Email: any;
  File: any;
  ImageFile: any;
  JSON: any;
  Mixed: any;
  UploadType: any;
  VideoFile: any;
};

export enum AdAccountType {
  POSTPAID = 'POSTPAID',
  PREPAID = 'PREPAID'
}

export type AdAccountTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<AdAccountType>>;
};

export enum AdminCredentialNameOption {
  /** Permission to see ads */
  ads = 'ads',
  /** Assigned user permissions modal on Facebook ad accounts */
  assigned_users = 'assigned_users',
  /** Permission to see categories */
  categories = 'categories',
  /** Permission to see categories p */
  categories_p = 'categories_p',
  /** Permission to see experimental ad accounts */
  experimental_ad_accounts = 'experimental_ad_accounts',
  /** Permission to see Facebook ad accounts */
  fb_ad_accounts = 'fb_ad_accounts',
  /** Permission to see finance */
  finance = 'finance',
  /** Permission to see fraud */
  fraud = 'fraud',
  /** Permission to see notifications */
  notifications = 'notifications',
  /** Permission to see reports */
  reports = 'reports',
  /** Permission to see stats */
  stats = 'stats',
  /** Permission to see system */
  system = 'system',
  /** Permission to see users */
  users = 'users'
}

export type AdminMetadata = {
  __typename?: 'AdminMetadata';
  adminId?: Maybe<Scalars['Int']>;
  adminName?: Maybe<Scalars['String']>;
  credentials?: Maybe<Array<Scalars['String']>>;
  culture?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  externalAdvertiserIds?: Maybe<Array<Scalars['ID']>>;
  globalNetwork?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  network?: Maybe<Scalars['String']>;
  oauthUserId?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  adminUserCredentials?: Maybe<Array<Maybe<Credential>>>;
  adminUserEmail?: Maybe<Scalars['String']>;
  adminUserFbEmail?: Maybe<Scalars['String']>;
  adminUserHasAgreedToTerms?: Maybe<Scalars['Boolean']>;
  adminUserHasAgreedToTermsTime?: Maybe<Scalars['String']>;
  adminUserId?: Maybe<Scalars['ID']>;
  adminUserIsDeleted?: Maybe<Scalars['Boolean']>;
  adminUserLogin?: Maybe<Scalars['String']>;
  adminUserName?: Maybe<Scalars['String']>;
  adminUserPhone?: Maybe<Scalars['String']>;
  adminUserSurname?: Maybe<Scalars['String']>;
  oauthUserId?: Maybe<Scalars['ID']>;
  permittedExternalAdvertisers?: Maybe<Array<ExternalAdvertiser>>;
};


export type AdminUserpermittedExternalAdvertisersArgs = {
  filter?: InputMaybe<ExternalAdvertiserFilter>;
  filterExclude?: InputMaybe<ExternalAdvertiserFilter>;
  filters?: InputMaybe<ExternalAdvertiserFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type AdminUserFilter = {
  adminUserEmail?: InputMaybe<Scalars['String']>;
  adminUserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  adminUserIsDeleted?: InputMaybe<Scalars['Boolean']>;
  adminUserName?: InputMaybe<Scalars['String']>;
  adminUserSurname?: InputMaybe<Scalars['String']>;
};

export type AdminUserFilters = {
  adminUserEmail?: InputMaybe<Array<StringFilter>>;
  adminUserId?: InputMaybe<Array<IdFilter>>;
  adminUserIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  adminUserName?: InputMaybe<Array<StringFilter>>;
  adminUserSurname?: InputMaybe<Array<StringFilter>>;
};

export enum AdminUserNotificationType {
  FINANCE = 'FINANCE',
  FRAUD = 'FRAUD',
  ONBOARDING = 'ONBOARDING'
}

export type AdminUsersCursored = {
  __typename?: 'AdminUsersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdminUser>>;
};

export type AutoRebalancedCreditLimit = {
  externalAdAccountId: Scalars['String'];
  spendCapLimit: Scalars['Int'];
};

export type BooleanFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type Business = {
  __typename?: 'Business';
  businessAddress?: Maybe<Scalars['String']>;
  businessBankAccountNumber?: Maybe<Scalars['String']>;
  businessBankDataId?: Maybe<Scalars['ID']>;
  businessBankName?: Maybe<Scalars['String']>;
  businessCity?: Maybe<Scalars['String']>;
  businessCountryId?: Maybe<Scalars['ID']>;
  businessCountryName?: Maybe<Scalars['String']>;
  businessCurrencyTag?: Maybe<Scalars['String']>;
  businessHasLocalFields?: Maybe<Scalars['Boolean']>;
  businessHasSelfOnboarding?: Maybe<Scalars['Boolean']>;
  businessId: Scalars['ID'];
  businessIsVatCommitted?: Maybe<Scalars['String']>;
  businessLocalAddress?: Maybe<Scalars['String']>;
  businessLocalBankAccountNumber?: Maybe<Scalars['String']>;
  businessLocalBankName?: Maybe<Scalars['String']>;
  businessLocalCity?: Maybe<Scalars['String']>;
  businessLocalCountry?: Maybe<Scalars['String']>;
  businessLocalName?: Maybe<Scalars['String']>;
  businessLocalRegNumber?: Maybe<Scalars['String']>;
  businessLocalVatNumber?: Maybe<Scalars['String']>;
  businessLocalZip?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessRegNumber?: Maybe<Scalars['String']>;
  businessVatNumber?: Maybe<Scalars['String']>;
  businessZip?: Maybe<Scalars['String']>;
  externalAdvertiser: ExternalAdvertiser;
  /** @deprecated Use externalAdvertiser field */
  externalAdvertiserId?: Maybe<Scalars['ID']>;
};

export type BusinessCursored = {
  __typename?: 'BusinessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Business>>;
};

export type BusinessEmailRecipients = {
  __typename?: 'BusinessEmailRecipients';
  adminUserEmail?: Maybe<Scalars['String']>;
  adminUserId?: Maybe<Scalars['ID']>;
  adminUserName?: Maybe<Scalars['String']>;
  adminUserNotificationType?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['ID']>;
  businessName?: Maybe<Scalars['String']>;
};

export type BusinessEmailRecipientsCursored = {
  __typename?: 'BusinessEmailRecipientsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<BusinessEmailRecipients>>;
};

export type BusinessEmailRecipientsFilter = {
  adminUserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  adminUserName?: InputMaybe<Scalars['String']>;
  adminUserNotificationType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  businessId: Array<Scalars['ID']>;
  businessName?: InputMaybe<Scalars['String']>;
  externalAdvertiserId?: InputMaybe<Scalars['ID']>;
};

export type BusinessFilters = {
  businessCountryId?: InputMaybe<Array<StringFilter>>;
  businessCurrencyTag?: InputMaybe<Array<StringFilter>>;
  businessHasLocalFields?: InputMaybe<Array<BooleanFilter>>;
  businessHasSelfOnboarding?: InputMaybe<Array<BooleanFilter>>;
  businessId?: InputMaybe<Array<IdFilter>>;
  businessName?: InputMaybe<Array<StringFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
};

export type BusinessOrderBy = {
  column: BusinessOrderByField;
  direction?: OrderByDirection;
};

export enum BusinessOrderByField {
  businessAddress = 'businessAddress',
  businessBankAccountNumber = 'businessBankAccountNumber',
  businessBankDataId = 'businessBankDataId',
  businessBankName = 'businessBankName',
  businessCity = 'businessCity',
  businessCountryId = 'businessCountryId',
  businessCountryName = 'businessCountryName',
  businessCurrencyTag = 'businessCurrencyTag',
  businessHasLocalFields = 'businessHasLocalFields',
  businessHasSelfOnboarding = 'businessHasSelfOnboarding',
  businessId = 'businessId',
  businessIsVatCommitted = 'businessIsVatCommitted',
  businessLocalAddress = 'businessLocalAddress',
  businessLocalBankAccountNumber = 'businessLocalBankAccountNumber',
  businessLocalBankName = 'businessLocalBankName',
  businessLocalCity = 'businessLocalCity',
  businessLocalCountry = 'businessLocalCountry',
  businessLocalName = 'businessLocalName',
  businessLocalRegNumber = 'businessLocalRegNumber',
  businessLocalVatNumber = 'businessLocalVatNumber',
  businessLocalZip = 'businessLocalZip',
  businessName = 'businessName',
  businessRegNumber = 'businessRegNumber',
  businessVatNumber = 'businessVatNumber',
  businessZip = 'businessZip',
  externalAdvertiserId = 'externalAdvertiserId'
}

export type BusinessUser = {
  __typename?: 'BusinessUser';
  business?: Maybe<BusinessUserBusiness>;
  businessUserId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  financePermission?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  ipPermission?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pendingEmail?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  twoFacStatus?: Maybe<Scalars['String']>;
};

export type BusinessUserBusiness = {
  __typename?: 'BusinessUserBusiness';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type BusinessUserFilter = {
  businessUserId?: InputMaybe<Scalars['ID']>;
};

export type Country = {
  __typename?: 'Country';
  countryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CountryFilter = {
  countryId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Credential = {
  __typename?: 'Credential';
  delete?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  write?: Maybe<Scalars['Boolean']>;
};

export type CredentialInput = {
  delete?: InputMaybe<Scalars['Boolean']>;
  name: AdminCredentialNameOption;
  read?: InputMaybe<Scalars['Boolean']>;
  write?: InputMaybe<Scalars['Boolean']>;
};

export type CreditSetting = {
  __typename?: 'CreditSetting';
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<Scalars['String']>;
  spendCapLimit?: Maybe<Scalars['String']>;
  spendCapLimitDefault?: Maybe<Scalars['String']>;
  spendCapLimitTransaction?: Maybe<Scalars['String']>;
};

export type CreditSettingCursored = {
  __typename?: 'CreditSettingCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<CreditSetting>>>;
};

export type CreditSettingFilter = {
  entityId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  entityType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Customer = {
  __typename?: 'Customer';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankCurrency?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['ID']>;
  bankLocalAccountNumber?: Maybe<Scalars['String']>;
  bankLocalName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bankTotalAmount?: Maybe<Scalars['String']>;
  bankType?: Maybe<Scalars['String']>;
  billingMinAmount?: Maybe<Scalars['Float']>;
  billingTaxPercentage?: Maybe<Scalars['Float']>;
  businessAddress?: Maybe<Scalars['String']>;
  businessBankAccountNumber?: Maybe<Scalars['String']>;
  businessBankDataId?: Maybe<Scalars['ID']>;
  businessBankName?: Maybe<Scalars['String']>;
  businessCity?: Maybe<Scalars['String']>;
  businessCountryId?: Maybe<Scalars['ID']>;
  businessCountryName?: Maybe<Scalars['String']>;
  businessCurrencyTag?: Maybe<Scalars['String']>;
  businessEmail?: Maybe<Scalars['String']>;
  businessFinanceEmail?: Maybe<Scalars['String']>;
  businessHasLocalFields?: Maybe<Scalars['Boolean']>;
  businessHasSelfOnboarding?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['ID']>;
  businessIsVatCommitted?: Maybe<Scalars['Int']>;
  businessLocalAddress?: Maybe<Scalars['String']>;
  businessLocalBankAccountNumber?: Maybe<Scalars['String']>;
  businessLocalBankName?: Maybe<Scalars['String']>;
  businessLocalCity?: Maybe<Scalars['String']>;
  businessLocalCountry?: Maybe<Scalars['String']>;
  businessLocalName?: Maybe<Scalars['String']>;
  businessLocalRegNumber?: Maybe<Scalars['String']>;
  businessLocalVatNumber?: Maybe<Scalars['String']>;
  businessLocalZip?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessRegNumber?: Maybe<Scalars['String']>;
  businessVatNumber?: Maybe<Scalars['String']>;
  businessZip?: Maybe<Scalars['String']>;
  customerAccountType?: Maybe<CustomerAccountType>;
  customerAddress?: Maybe<Scalars['String']>;
  /**  Amount of funds in the customer's wallet or on his ad accounts that's eligible for transfer.  */
  customerAvailableFunds?: Maybe<Scalars['Float']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCompanyName?: Maybe<Scalars['String']>;
  customerContractSigned?: Maybe<Scalars['Int']>;
  customerCountryId?: Maybe<Scalars['ID']>;
  customerCountryName?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerExternalId?: Maybe<Scalars['ID']>;
  customerFullName?: Maybe<Scalars['String']>;
  customerHasEContract?: Maybe<Scalars['Int']>;
  /**  Whether any of the customer's ad accounts has unlimited spend cap. In hundredths of base currency.  */
  customerHasUnlimitedSpendCap?: Maybe<Scalars['Boolean']>;
  customerHasValidEContract?: Maybe<Scalars['Int']>;
  customerId?: Maybe<Scalars['ID']>;
  customerInternalId?: Maybe<Scalars['ID']>;
  customerIsActivated?: Maybe<Scalars['Int']>;
  customerIsDeleted?: Maybe<Scalars['Int']>;
  customerIsFullyRegistered?: Maybe<Scalars['Int']>;
  customerIsTest?: Maybe<Scalars['Int']>;
  customerIsValidated?: Maybe<Scalars['Int']>;
  customerIsVatCommitted?: Maybe<Scalars['Int']>;
  customerLocalAddress?: Maybe<Scalars['String']>;
  customerLocalCity?: Maybe<Scalars['String']>;
  customerLocalCompanyName?: Maybe<Scalars['String']>;
  customerLocalCountry?: Maybe<Scalars['String']>;
  customerLocalFullName?: Maybe<Scalars['String']>;
  customerLocalName?: Maybe<Scalars['String']>;
  customerLocalRegNumber?: Maybe<Scalars['String']>;
  customerLocalSurname?: Maybe<Scalars['String']>;
  customerLocalVatNumber?: Maybe<Scalars['String']>;
  customerLocalZip?: Maybe<Scalars['String']>;
  customerMailSubscribed?: Maybe<Scalars['Int']>;
  customerName?: Maybe<Scalars['String']>;
  customerNotice?: Maybe<Array<CustomerNotice>>;
  customerPhone?: Maybe<Scalars['String']>;
  customerProfileImage?: Maybe<ProfileImage>;
  customerProfileImageId?: Maybe<Scalars['ID']>;
  customerRegNumber?: Maybe<Scalars['String']>;
  customerSalesforceId?: Maybe<Scalars['ID']>;
  customerStatus?: Maybe<CustomerStatus>;
  customerSurname?: Maybe<Scalars['String']>;
  customerVatNumber?: Maybe<Scalars['String']>;
  customerZip?: Maybe<Scalars['String']>;
  deposits?: Maybe<Array<Deposit>>;
  /**  Sum of funds left for active ad accounts that the customer has access to. In hundredths of base currency.  */
  externalAdAccountFundsLeftActive?: Maybe<Scalars['Float']>;
  /**  Sum of funds left for active ad accounts that the customer has access to.  */
  externalAdAccountFundsLeftActiveInCents?: Maybe<Scalars['Int']>;
  /**  Sum of funds left for closed ad accounts that the customer has access to.  */
  externalAdAccountFundsLeftClosed?: Maybe<Scalars['Float']>;
  /**  Sum of funds left for closed ad accounts that the customer has access to.  */
  externalAdAccountFundsLeftClosedInCents?: Maybe<Scalars['Int']>;
  /**  Sum of funds left for disabled ad accounts that the customer has access to. In hundredths of base currency.  */
  externalAdAccountFundsLeftDisabled?: Maybe<Scalars['Float']>;
  /**  Sum of funds left for disabled ad accounts that the customer has access to.  */
  externalAdAccountFundsLeftDisabledInCents?: Maybe<Scalars['Int']>;
  /**  Sum of funds left for all ad accounts that the customer has access to.  */
  externalAdAccountFundsLeftTotal?: Maybe<Scalars['Float']>;
  /**  Sum of funds left for all ad accounts that the customer has access to. In hundredths of base currency.  */
  externalAdAccountFundsLeftTotalInCents?: Maybe<Scalars['Int']>;
  externalAdAccounts?: Maybe<Array<ExternalAdAccount>>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  statistics?: Maybe<Array<Statistics>>;
  users?: Maybe<Array<User>>;
  walletBalance?: Maybe<Scalars['Float']>;
  walletId?: Maybe<Scalars['ID']>;
};


export type CustomerdepositsArgs = {
  filter?: InputMaybe<DepositFilter>;
  filterExclude?: InputMaybe<DepositFilter>;
  filters?: InputMaybe<DepositFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type CustomerexternalAdAccountsArgs = {
  filter?: InputMaybe<ExternalAdAccountFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
  filters?: InputMaybe<ExternalAdAccountFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type CustomerstatisticsArgs = {
  filter?: InputMaybe<StatisticsFilter>;
  filterExclude?: InputMaybe<StatisticsFilter>;
  filters?: InputMaybe<StatisticsFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type CustomerusersArgs = {
  filter?: InputMaybe<UserFilter>;
  filterExclude?: InputMaybe<UserFilter>;
  filters?: InputMaybe<UserFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export enum CustomerAccountType {
  EXPRESS = 'EXPRESS',
  FBS_A = 'FBS_A',
  FBS_C = 'FBS_C'
}

export type CustomerAccountTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<CustomerAccountType>>;
};

export type CustomerFilter = {
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerExternalId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerFullName?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerIsTest?: InputMaybe<Scalars['Boolean']>;
  customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerStatus?: InputMaybe<Scalars['String']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  externalAdAccountId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdAccountName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CustomerFilters = {
  customerAccountType?: InputMaybe<Array<CustomerAccountTypeFilter>>;
  customerCompanyName?: InputMaybe<Array<StringFilter>>;
  customerEmail?: InputMaybe<Array<StringFilter>>;
  customerExternalId?: InputMaybe<Array<IdFilter>>;
  customerFullName?: InputMaybe<Array<StringFilter>>;
  customerId?: InputMaybe<Array<IdFilter>>;
  customerIsActivated?: InputMaybe<Array<BooleanFilter>>;
  customerIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  customerIsTest?: InputMaybe<Array<BooleanFilter>>;
  customerIsValidated?: InputMaybe<Array<BooleanFilter>>;
  customerName?: InputMaybe<Array<StringFilter>>;
  customerStatus?: InputMaybe<Array<CustomerStatusFilter>>;
  customerSurname?: InputMaybe<Array<StringFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountName?: InputMaybe<Array<StringFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
  userEmail?: InputMaybe<Array<StringFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type CustomerNotice = {
  __typename?: 'CustomerNotice';
  customerId: Scalars['ID'];
  customerNoticeDateAdded?: Maybe<Scalars['String']>;
  customerNoticeId: Scalars['ID'];
  customerNoticeIsDeleted: Scalars['Boolean'];
  customerNoticeIsMass: Scalars['Boolean'];
  customerNoticeIsNews: Scalars['Boolean'];
  customerNoticeIsRead?: Maybe<Scalars['Boolean']>;
  customerNoticeIsTranslated: Scalars['Boolean'];
  customerNoticeMessage?: Maybe<Scalars['String']>;
  customerNoticeNoticeType: CustomerNoticeType;
  customerNoticeTitle?: Maybe<Scalars['String']>;
  customerNoticeVisible: Scalars['Boolean'];
};

export type CustomerNoticeCursored = {
  __typename?: 'CustomerNoticeCursored';
  /**  Pagination cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  List of CustomerNotice items  */
  items?: Maybe<Array<CustomerNotice>>;
};

export type CustomerNoticeFilter = {
  customerId?: InputMaybe<Array<IdFilter>>;
  customerNoticeDateAdded?: InputMaybe<Array<StringFilter>>;
  customerNoticeId?: InputMaybe<Array<IdFilter>>;
  customerNoticeIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  customerNoticeIsMass?: InputMaybe<Array<BooleanFilter>>;
  customerNoticeIsNews?: InputMaybe<Array<BooleanFilter>>;
  customerNoticeIsRead?: InputMaybe<Array<BooleanFilter>>;
  customerNoticeIsTranslated?: InputMaybe<Array<BooleanFilter>>;
  customerNoticeMessage?: InputMaybe<Array<StringFilter>>;
  customerNoticeNoticeType?: InputMaybe<Array<StringFilter>>;
  customerNoticeTitle?: InputMaybe<Array<StringFilter>>;
  customerNoticeVisible?: InputMaybe<Array<BooleanFilter>>;
};

export type CustomerNoticeOrderBy = {
  column: CustomerNoticeOrderByField;
  direction?: OrderByDirection;
};

export enum CustomerNoticeOrderByField {
  customerId = 'customerId',
  customerNoticeDateAdded = 'customerNoticeDateAdded',
  customerNoticeId = 'customerNoticeId',
  customerNoticeIsDeleted = 'customerNoticeIsDeleted',
  customerNoticeIsMass = 'customerNoticeIsMass',
  customerNoticeIsNews = 'customerNoticeIsNews',
  customerNoticeIsRead = 'customerNoticeIsRead',
  customerNoticeIsTranslated = 'customerNoticeIsTranslated',
  customerNoticeMessage = 'customerNoticeMessage',
  customerNoticeNoticeType = 'customerNoticeNoticeType',
  customerNoticeTitle = 'customerNoticeTitle',
  customerNoticeVisible = 'customerNoticeVisible'
}

export enum CustomerNoticeType {
  ADVERTISER = 'ADVERTISER',
  PUBLISHER = 'PUBLISHER'
}

export enum CustomerStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  PENDING = 'PENDING'
}

export type CustomerStatusFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<CustomerStatus>>;
};

export type CustomersCursored = {
  __typename?: 'CustomersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Customer>>;
};

export type DateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['DateOptionalTime']>;
};

export type DateRangeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTimeRange'];
};

export type Deposit = {
  __typename?: 'Deposit';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankCurrency?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['ID']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCompanyName?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['Email']>;
  customerId?: Maybe<Scalars['ID']>;
  customerMinAmount?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerSurname?: Maybe<Scalars['String']>;
  customerVatNumber?: Maybe<Scalars['String']>;
  customerZip?: Maybe<Scalars['String']>;
  depositAmount?: Maybe<Scalars['Float']>;
  depositDescription?: Maybe<Scalars['String']>;
  depositDiscount?: Maybe<Scalars['Float']>;
  depositEntryDate?: Maybe<Scalars['DateTime']>;
  depositId?: Maybe<Scalars['ID']>;
  depositInvoiceNumber?: Maybe<Scalars['String']>;
  depositInvoiceUrl?: Maybe<Scalars['String']>;
  depositLink?: Maybe<Scalars['String']>;
  depositModifierFullName?: Maybe<Scalars['String']>;
  depositPaymentDueTime?: Maybe<Scalars['DateTime']>;
  depositPaymentType?: Maybe<PaymentType>;
  /** base64 encoded proforma invoice pdf. */
  depositProformaInvoice?: Maybe<Scalars['String']>;
  depositReferenceFinal?: Maybe<Scalars['String']>;
  depositReferenceNumber?: Maybe<Scalars['Int']>;
  depositReferenceYear?: Maybe<Scalars['Int']>;
  depositStatus?: Maybe<TransactionStatus>;
  depositStatusTime?: Maybe<Scalars['DateTime']>;
  depositTaxPercentage?: Maybe<Scalars['Float']>;
  externalAdAccountTransactions?: Maybe<Array<Maybe<ExternalAdAccountTransaction>>>;
};

export type DepositFilter = {
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerName?: InputMaybe<Scalars['String']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  depositEntryDateFrom?: InputMaybe<Scalars['DateOptionalTime']>;
  depositEntryDateTo?: InputMaybe<Scalars['DateOptionalTime']>;
  depositId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  depositInvoiceNumber?: InputMaybe<Scalars['String']>;
  depositPaymentType?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  depositReferenceNumber?: InputMaybe<Scalars['String']>;
  depositReferenceYear?: InputMaybe<Scalars['Int']>;
  depositStatus?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  depositStatusTime?: InputMaybe<Scalars['String']>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DepositFilters = {
  bankAccountType?: InputMaybe<Array<StringFilter>>;
  bankId?: InputMaybe<Array<IdFilter>>;
  customerCompanyName?: InputMaybe<Array<StringFilter>>;
  customerId?: InputMaybe<Array<IdFilter>>;
  customerName?: InputMaybe<Array<StringFilter>>;
  customerSurname?: InputMaybe<Array<StringFilter>>;
  depositEntryDate?: InputMaybe<Array<DateRangeFilter>>;
  depositId?: InputMaybe<Array<IdFilter>>;
  depositInvoiceNumber?: InputMaybe<Array<StringFilter>>;
  depositPaymentType?: InputMaybe<Array<PaymentTypeFilter>>;
  depositReferenceNumber?: InputMaybe<Array<StringFilter>>;
  depositReferenceYear?: InputMaybe<Array<IntFilter>>;
  depositStatus?: InputMaybe<Array<TransactionStatusFilter>>;
  depositStatusTime?: InputMaybe<Array<DateRangeFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
};

export type DepositsCursored = {
  __typename?: 'DepositsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<Deposit>>>;
};

export type ExtendedCreditInvoiceGroup = {
  __typename?: 'ExtendedCreditInvoiceGroup';
  currentMonthSpend?: Maybe<Scalars['Float']>;
  extendedCreditId?: Maybe<Scalars['ID']>;
  extendedCreditInvoiceGroupAccountType?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupAmountSpent?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupCreditLimit?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupCreditLimitTransaction?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupCreditLimitType?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupCurrency?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupDefaultCreditLimit?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupFundsLeft?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  extendedCreditInvoiceGroupLifetimeSpend?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupName?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupSpendCap?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupSpendCapIsUnlimited?: Maybe<Scalars['Boolean']>;
  extendedCreditInvoiceGroupSpendCapRatio?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupStatus?: Maybe<Scalars['String']>;
  externalAdAccounts?: Maybe<Array<Maybe<ExternalAdAccount>>>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  lastMonthSpend?: Maybe<Scalars['Float']>;
  statistics?: Maybe<Array<Maybe<Statistics>>>;
};


export type ExtendedCreditInvoiceGroupexternalAdAccountsArgs = {
  filter?: InputMaybe<ExternalAdAccountFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type ExtendedCreditInvoiceGroupstatisticsArgs = {
  filter?: InputMaybe<StatisticsFilter>;
  filterExclude?: InputMaybe<StatisticsFilter>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type ExtendedCreditInvoiceGroupFilter = {
  extendedCreditId?: InputMaybe<Array<IdFilter>>;
  extendedCreditInvoiceGroupAccountType?: InputMaybe<Array<StringFilter>>;
  extendedCreditInvoiceGroupCurrency?: InputMaybe<Array<StringFilter>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<IdFilter>>;
  extendedCreditInvoiceGroupName?: InputMaybe<Array<StringFilter>>;
  extendedCreditInvoiceGroupSpendCapIsUnlimited?: InputMaybe<Array<BooleanFilter>>;
  extendedCreditInvoiceGroupStatus?: InputMaybe<Array<StringFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
};

export type ExtendedCreditInvoiceGroupOrderBy = {
  column: ExtendedCreditInvoiceGroupOrderByField;
  direction?: OrderByDirection;
};

export enum ExtendedCreditInvoiceGroupOrderByField {
  currentMonthSpend = 'currentMonthSpend',
  extendedCreditId = 'extendedCreditId',
  extendedCreditInvoiceGroupAccountType = 'extendedCreditInvoiceGroupAccountType',
  extendedCreditInvoiceGroupAmountSpent = 'extendedCreditInvoiceGroupAmountSpent',
  extendedCreditInvoiceGroupCreditLimit = 'extendedCreditInvoiceGroupCreditLimit',
  extendedCreditInvoiceGroupCreditLimitTransaction = 'extendedCreditInvoiceGroupCreditLimitTransaction',
  extendedCreditInvoiceGroupCreditLimitType = 'extendedCreditInvoiceGroupCreditLimitType',
  extendedCreditInvoiceGroupCurrency = 'extendedCreditInvoiceGroupCurrency',
  extendedCreditInvoiceGroupDefaultCreditLimit = 'extendedCreditInvoiceGroupDefaultCreditLimit',
  extendedCreditInvoiceGroupFundsLeft = 'extendedCreditInvoiceGroupFundsLeft',
  extendedCreditInvoiceGroupId = 'extendedCreditInvoiceGroupId',
  extendedCreditInvoiceGroupLifetimeSpend = 'extendedCreditInvoiceGroupLifetimeSpend',
  extendedCreditInvoiceGroupName = 'extendedCreditInvoiceGroupName',
  extendedCreditInvoiceGroupSpendCap = 'extendedCreditInvoiceGroupSpendCap',
  extendedCreditInvoiceGroupSpendCapRatio = 'extendedCreditInvoiceGroupSpendCapRatio',
  extendedCreditInvoiceGroupStatus = 'extendedCreditInvoiceGroupStatus',
  externalAdvertiserId = 'externalAdvertiserId',
  lastMonthSpend = 'lastMonthSpend'
}

export type ExtendedCreditInvoiceGroupsCursored = {
  __typename?: 'ExtendedCreditInvoiceGroupsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ExtendedCreditInvoiceGroup>>>;
};

export type ExternalAdAccount = {
  __typename?: 'ExternalAdAccount';
  currentMonthSpend?: Maybe<Scalars['Float']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerFullName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  extendedCreditInvoiceGroupCreditLimit?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupCreditLimitTransaction?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupCreditLimitType?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupDefaultCreditLimit?: Maybe<Scalars['Float']>;
  extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  extendedCreditInvoiceGroupName?: Maybe<Scalars['String']>;
  externalAdAccountActivity?: Maybe<Array<ExternalAdAccountActivity>>;
  externalAdAccountAmountSpent?: Maybe<Scalars['Float']>;
  externalAdAccountAmountSpentInCents?: Maybe<Scalars['Int']>;
  externalAdAccountAutoRebalancedCreditLimit?: Maybe<Scalars['Float']>;
  externalAdAccountBalance?: Maybe<Scalars['Float']>;
  externalAdAccountBalanceInCents?: Maybe<Scalars['Int']>;
  externalAdAccountCreditLimit?: Maybe<Scalars['Float']>;
  externalAdAccountCreditLimitTransaction?: Maybe<Scalars['Float']>;
  externalAdAccountCreditLimitType?: Maybe<Scalars['String']>;
  externalAdAccountCreditLimitUsedRatio?: Maybe<Scalars['Float']>;
  externalAdAccountCurrency?: Maybe<FacebookCurrency>;
  externalAdAccountDefaultCreditLimit?: Maybe<Scalars['Float']>;
  externalAdAccountDetailedStatsEnabled?: Maybe<Scalars['Boolean']>;
  externalAdAccountFundingSourceId?: Maybe<Scalars['ID']>;
  externalAdAccountFundsLeft?: Maybe<Scalars['Float']>;
  externalAdAccountId?: Maybe<Scalars['ID']>;
  externalAdAccountImportedAt?: Maybe<Scalars['DateOptionalTime']>;
  externalAdAccountLifetimeSpend?: Maybe<Scalars['Float']>;
  externalAdAccountMaxSpendCap?: Maybe<Scalars['Float']>;
  externalAdAccountMaxSpendCapInCents?: Maybe<Scalars['Int']>;
  externalAdAccountMinSpendCap?: Maybe<Scalars['Float']>;
  externalAdAccountName?: Maybe<Scalars['String']>;
  externalAdAccountSpendCap?: Maybe<Scalars['Float']>;
  externalAdAccountSpendCapInCents?: Maybe<Scalars['Int']>;
  externalAdAccountSpendCapIsUnlimited?: Maybe<Scalars['Boolean']>;
  externalAdAccountSpendCapRatio?: Maybe<Scalars['Float']>;
  externalAdAccountSpendFactor?: Maybe<Scalars['Float']>;
  externalAdAccountStatus?: Maybe<ExternalAdAccountStatus>;
  externalAdAccountTimezone?: Maybe<FacebookTimezone>;
  externalAdAccountType?: Maybe<Scalars['String']>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  externalAdvertiserName?: Maybe<Scalars['String']>;
  lastMonthSpend?: Maybe<Scalars['Float']>;
  statistics?: Maybe<Array<Maybe<Statistics>>>;
};


export type ExternalAdAccountexternalAdAccountActivityArgs = {
  filters?: InputMaybe<ExternalAdAccountActivityFilter>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type ExternalAdAccountstatisticsArgs = {
  filter?: InputMaybe<StatisticsFilter>;
  filterExclude?: InputMaybe<StatisticsFilter>;
  filters?: InputMaybe<StatisticsFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type ExternalAdAccountActivity = {
  __typename?: 'ExternalAdAccountActivity';
  actorId: Scalars['ID'];
  actorName?: Maybe<Scalars['String']>;
  applicationId: Scalars['ID'];
  applicationName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  eventTime: Scalars['String'];
  eventTimeInTimezone: Scalars['String'];
  eventType: Scalars['String'];
  extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  externalAdAccountId: Scalars['ID'];
  externalAdAccountName?: Maybe<Scalars['String']>;
  externalAdAccountTimezone?: Maybe<Scalars['String']>;
  externalAdAccountType?: Maybe<Scalars['String']>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  externalAdvertiserName?: Maybe<Scalars['String']>;
  extraData: Scalars['String'];
  importedAt: Scalars['String'];
  objectId: Scalars['ID'];
  objectName?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  translatedEventType?: Maybe<Scalars['String']>;
};

export type ExternalAdAccountActivityCursored = {
  __typename?: 'ExternalAdAccountActivityCursored';
  /**  Pagination cursor  */
  cursor?: Maybe<Scalars['String']>;
  /**  List of ExternalAdAccountActivity records  */
  items?: Maybe<Array<ExternalAdAccountActivity>>;
};

export type ExternalAdAccountActivityFilter = {
  actorId?: InputMaybe<Array<IdFilter>>;
  actorName?: InputMaybe<Array<StringFilter>>;
  applicationId?: InputMaybe<Array<IdFilter>>;
  applicationName?: InputMaybe<Array<StringFilter>>;
  category?: InputMaybe<Array<StringFilter>>;
  eventTime?: InputMaybe<Array<StringFilter>>;
  eventType?: InputMaybe<Array<StringFilter>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountName?: InputMaybe<Array<StringFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
  externalAdvertiserName?: InputMaybe<Array<StringFilter>>;
  importedAt?: InputMaybe<Array<StringFilter>>;
  importedAtInUtc?: InputMaybe<Array<StringFilter>>;
  objectId?: InputMaybe<Array<IdFilter>>;
  objectName?: InputMaybe<Array<StringFilter>>;
  objectType?: InputMaybe<Array<StringFilter>>;
};

export type ExternalAdAccountActivityOrderBy = {
  column: ExternalAdAccountActivityOrderByField;
  direction?: OrderByDirection;
};

export enum ExternalAdAccountActivityOrderByField {
  actorId = 'actorId',
  actorName = 'actorName',
  applicationId = 'applicationId',
  applicationName = 'applicationName',
  category = 'category',
  eventTime = 'eventTime',
  eventTimeInTimezone = 'eventTimeInTimezone',
  eventType = 'eventType',
  extendedCreditInvoiceGroupId = 'extendedCreditInvoiceGroupId',
  externalAdAccountId = 'externalAdAccountId',
  externalAdAccountName = 'externalAdAccountName',
  externalAdAccountTimezone = 'externalAdAccountTimezone',
  externalAdvertiserId = 'externalAdvertiserId',
  externalAdvertiserName = 'externalAdvertiserName',
  extraData = 'extraData',
  importedAt = 'importedAt',
  objectId = 'objectId',
  objectName = 'objectName',
  objectType = 'objectType',
  translatedEventType = 'translatedEventType'
}

export type ExternalAdAccountAgenciesCursored = {
  __typename?: 'ExternalAdAccountAgenciesCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ExternalAdAccountAgency>>;
};

export type ExternalAdAccountAgency = {
  __typename?: 'ExternalAdAccountAgency';
  /**  Time when the agency requested access to the ad account.  */
  externalAdAccountAgencyAccessRequestedTime: Scalars['String'];
  /**  Status of the agency's access to the ad account.  */
  externalAdAccountAgencyAccessStatus: Scalars['String'];
  /**  Time when the agency's access to the ad account was last updated.  */
  externalAdAccountAgencyAccessUpdatedTime: Scalars['String'];
  /**  Time when the agency was deleted. Null if the agency is not deleted.  */
  externalAdAccountAgencyDeletedAt?: Maybe<Scalars['String']>;
  /**  Facebook business ID of the assigned agency.  */
  externalAdAccountAgencyId: Scalars['ID'];
  /**  Whether the agency is deleted.  */
  externalAdAccountAgencyIsDeleted: Scalars['Boolean'];
  /**  Name of the assigned agency.  */
  externalAdAccountAgencyName: Scalars['String'];
  /**  Tasks that the agency is permitted to perform on the ad account.  */
  externalAdAccountAgencyPermittedTasks: Array<Maybe<ExternalAdAccountAgencyTask>>;
  /**  Status of the agency's verification.  */
  externalAdAccountAgencyVerificationStatus: Scalars['String'];
  /**  Facebook ad account ID.  */
  externalAdAccountId: Scalars['ID'];
};

export type ExternalAdAccountAgencyFilter = {
  externalAdAccountAgencyId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountAgencyIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  externalAdAccountAgencyName?: InputMaybe<Array<StringFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
};

export type ExternalAdAccountAgencyInput = {
  /** Business ID of the agency that should be updated. */
  externalAdAccountAgencyId: Scalars['ID'];
  /** Tasks that the agency should be permitted to perform on the ad account. */
  externalAdAccountAgencyPermittedTasks: Array<ExternalAdAccountAgencyTask>;
};

export type ExternalAdAccountAgencyOrderBy = {
  column: ExternalAdAccountAgencyOrderByColumn;
  direction?: OrderByDirection;
};

export enum ExternalAdAccountAgencyOrderByColumn {
  externalAdAccountAgencyAccessRequestedTime = 'externalAdAccountAgencyAccessRequestedTime',
  externalAdAccountAgencyAccessStatus = 'externalAdAccountAgencyAccessStatus',
  externalAdAccountAgencyAccessUpdatedTime = 'externalAdAccountAgencyAccessUpdatedTime',
  externalAdAccountAgencyId = 'externalAdAccountAgencyId',
  externalAdAccountAgencyName = 'externalAdAccountAgencyName',
  externalAdAccountAgencyPermittedTasks = 'externalAdAccountAgencyPermittedTasks',
  externalAdAccountAgencyVerificationStatus = 'externalAdAccountAgencyVerificationStatus',
  externalAdAccountId = 'externalAdAccountId'
}

export enum ExternalAdAccountAgencyTask {
  AA_ANALYZE = 'AA_ANALYZE',
  ADVERTISE = 'ADVERTISE',
  ANALYZE = 'ANALYZE',
  DRAFT = 'DRAFT',
  MANAGE = 'MANAGE'
}

export type ExternalAdAccountAssignedUser = {
  __typename?: 'ExternalAdAccountAssignedUser';
  assignedUserId: Scalars['ID'];
  externalAdAccountId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  tasks?: Maybe<Scalars['String']>;
};

export type ExternalAdAccountAssignedUsersInput = {
  tasks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  user?: InputMaybe<Scalars['String']>;
};

export type ExternalAdAccountFilter = {
  customerFullName?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  extendedCreditInvoiceGroupName?: InputMaybe<Scalars['String']>;
  externalAdAccountCurrency?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAdAccountDetailedStatsEnabled?: InputMaybe<Scalars['Boolean']>;
  externalAdAccountFundingSourceId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdAccountId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdAccountInInvoiceGroup?: InputMaybe<Scalars['Boolean']>;
  externalAdAccountName?: InputMaybe<Scalars['String']>;
  externalAdAccountStatus?: InputMaybe<Array<ExternalAdAccountStatus>>;
  externalAdAccountTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAdAccountType?: InputMaybe<Array<InputMaybe<AdAccountType>>>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdvertiserName?: InputMaybe<Scalars['String']>;
};

export type ExternalAdAccountFilters = {
  customerFullName?: InputMaybe<Array<StringFilter>>;
  customerId?: InputMaybe<Array<IdFilter>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<IdFilter>>;
  extendedCreditInvoiceGroupName?: InputMaybe<Array<StringFilter>>;
  externalAdAccountCurrency?: InputMaybe<Array<FacebookCurrencyFilter>>;
  externalAdAccountDetailedStatsEnabled?: InputMaybe<Array<BooleanFilter>>;
  externalAdAccountFundingSourceId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountInInvoiceGroup?: InputMaybe<Array<BooleanFilter>>;
  externalAdAccountName?: InputMaybe<Array<StringFilter>>;
  externalAdAccountSpendCapIsUnlimited?: InputMaybe<Array<BooleanFilter>>;
  externalAdAccountStatus?: InputMaybe<Array<ExternalAdAccountStatus>>;
  externalAdAccountTimezone?: InputMaybe<Array<FacebookTimezoneFilter>>;
  externalAdAccountType?: InputMaybe<Array<AdAccountTypeFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
  externalAdvertiserName?: InputMaybe<Array<StringFilter>>;
};

export enum ExternalAdAccountStatus {
  ACTIVE = 'ACTIVE',
  ANY_ACTIVE = 'ANY_ACTIVE',
  ANY_CLOSED = 'ANY_CLOSED',
  CLOSED = 'CLOSED',
  DISABLED = 'DISABLED',
  IN_GRACE_PERIOD = 'IN_GRACE_PERIOD',
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  PENDING_RISK_REVIEW = 'PENDING_RISK_REVIEW',
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
  UNSETTLED = 'UNSETTLED'
}

export type ExternalAdAccountStatusFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<ExternalAdAccountStatus>>;
};

/** External ad account transaction */
export type ExternalAdAccountTransaction = {
  __typename?: 'ExternalAdAccountTransaction';
  customerId?: Maybe<Scalars['ID']>;
  externalAdAccount: ExternalAdAccount;
  /** @deprecated Use externalAdAccount subquery instead */
  externalAdAccountCurrency?: Maybe<Scalars['String']>;
  /** @deprecated Use externalAdAccount subquery instead */
  externalAdAccountId: Scalars['ID'];
  /** @deprecated Use externalAdAccount subquery instead */
  externalAdAccountName?: Maybe<Scalars['String']>;
  externalAdAccountTransactionAmount: Scalars['Float'];
  externalAdAccountTransactionId: Scalars['ID'];
  externalAdAccountTransactionModificationTime?: Maybe<Scalars['String']>;
  externalAdAccountTransactionStatus: ExternalAdAccountTransactionStatus;
  transactionExternalId?: Maybe<Scalars['ID']>;
  transactionExternalTransactionType?: Maybe<Scalars['String']>;
};

export type ExternalAdAccountTransactionFilter = {
  customerId?: InputMaybe<Scalars['ID']>;
  externalAdAccountTransactionId?: InputMaybe<Array<Scalars['String']>>;
  externalAdAccountTransactionStatus?: InputMaybe<Array<ExternalAdAccountTransactionStatus>>;
};

export type ExternalAdAccountTransactionFilters = {
  customerId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountTransactionId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountTransactionStatus?: InputMaybe<Array<ExternalAdAccountTransactionStatusFilter>>;
};

export enum ExternalAdAccountTransactionStatus {
  CANCELLED = 'CANCELLED',
  FB_PENDING = 'FB_PENDING',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  REJECTED = 'REJECTED'
}

export type ExternalAdAccountTransactionStatusFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<ExternalAdAccountTransactionStatus>>;
};

export type ExternalAdAccountTransactionsCursored = {
  __typename?: 'ExternalAdAccountTransactionsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ExternalAdAccountTransaction>>;
};

export type ExternalAdAccountsAggregated = {
  __typename?: 'ExternalAdAccountsAggregated';
  currentMonthSpend?: Maybe<Scalars['Float']>;
  externalAdAccountAmountSpent?: Maybe<Scalars['Float']>;
  externalAdAccountBalance?: Maybe<Scalars['Float']>;
  externalAdAccountCurrency?: Maybe<Scalars['String']>;
  externalAdAccountFundsLeft?: Maybe<Scalars['Float']>;
  externalAdAccountFundsLeftAreUnlimited?: Maybe<Scalars['Boolean']>;
  externalAdAccountLifetimeSpend?: Maybe<Scalars['Float']>;
  externalAdAccountSpendCap?: Maybe<Scalars['Float']>;
  externalAdAccountStatus?: Maybe<ExternalAdAccountStatus>;
  externalAdAccountType?: Maybe<Scalars['String']>;
  lastMonthSpend?: Maybe<Scalars['Float']>;
};

export type ExternalAdAccountsCursored = {
  __typename?: 'ExternalAdAccountsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ExternalAdAccount>>>;
};

export type ExternalAdvertiser = {
  __typename?: 'ExternalAdvertiser';
  adminUsers?: Maybe<Array<AdminUser>>;
  business?: Maybe<Business>;
  externalAdvertiserCurrency?: Maybe<Scalars['String']>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  externalAdvertiserIsActive?: Maybe<Scalars['Boolean']>;
  externalAdvertiserName?: Maybe<Scalars['String']>;
  externalAdvertiserUserId?: Maybe<Scalars['String']>;
};


export type ExternalAdvertiseradminUsersArgs = {
  filter?: InputMaybe<AdminUserFilter>;
  filterExclude?: InputMaybe<AdminUserFilter>;
  filters?: InputMaybe<AdminUserFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type ExternalAdvertiserFilter = {
  externalAdvertiserCurrency?: InputMaybe<Scalars['String']>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdvertiserIsActive?: InputMaybe<Scalars['Boolean']>;
  externalAdvertiserName?: InputMaybe<Scalars['String']>;
  externalAdvertiserUserId?: InputMaybe<Scalars['String']>;
};

export type ExternalAdvertiserFilters = {
  externalAdvertiserCurrency?: InputMaybe<Array<StringFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
  externalAdvertiserIsActive?: InputMaybe<Array<BooleanFilter>>;
  externalAdvertiserName?: InputMaybe<Array<StringFilter>>;
  externalAdvertiserUserId?: InputMaybe<Array<StringFilter>>;
};

export type ExternalAdvertisersCursored = {
  __typename?: 'ExternalAdvertisersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ExternalAdvertiser>>;
};

/** Currencies supported by Facebook. */
export enum FacebookCurrency {
  /** Uae Dirham */
  AED = 'AED',
  /** Argentine Peso */
  ARS = 'ARS',
  /** Australian Dollar */
  AUD = 'AUD',
  /** Bangladeshi Taka */
  BDT = 'BDT',
  /** Bolivian Boliviano */
  BOB = 'BOB',
  /** Brazilian Real */
  BRL = 'BRL',
  /** Canadian Dollar */
  CAD = 'CAD',
  /** Swiss Franc */
  CHF = 'CHF',
  /** Chilean Peso */
  CLP = 'CLP',
  /** Chinese Yuan */
  CNY = 'CNY',
  /** Colombian Peso */
  COP = 'COP',
  /** Costa Rican Colon */
  CRC = 'CRC',
  /** Czech Koruna */
  CZK = 'CZK',
  /** Danish Krone */
  DKK = 'DKK',
  /** Algerian Dinar */
  DZD = 'DZD',
  /** Egyptian Pounds */
  EGP = 'EGP',
  /** Euro */
  EUR = 'EUR',
  /** British Pound */
  GBP = 'GBP',
  /** Guatemalan Quetza */
  GTQ = 'GTQ',
  /** Hong Kong Dollar */
  HKD = 'HKD',
  /** Honduran Lempira */
  HNL = 'HNL',
  /** Hungarian Forint */
  HUF = 'HUF',
  /** Indonesian Rupiah */
  IDR = 'IDR',
  /** Israeli New Shekel */
  ILS = 'ILS',
  /** Indian Rupee */
  INR = 'INR',
  /** Iceland Krona */
  ISK = 'ISK',
  /** Japanese Yen */
  JPY = 'JPY',
  /** Kenyan Shilling */
  KES = 'KES',
  /** Korean Won */
  KRW = 'KRW',
  /** Macau Patacas */
  MOP = 'MOP',
  /** Mexican Peso */
  MXN = 'MXN',
  /** Malaysian Ringgit */
  MYR = 'MYR',
  /** Nigerian Naira */
  NGN = 'NGN',
  /** Nicaraguan Cordoba */
  NIO = 'NIO',
  /** Norwegian Krone */
  NOK = 'NOK',
  /** New Zealand Dollar */
  NZD = 'NZD',
  /** Peruvian Nuevo Sol */
  PEN = 'PEN',
  /** Philippine Peso */
  PHP = 'PHP',
  /** Pakistani Rupee */
  PKR = 'PKR',
  /** Polish Zloty */
  PLN = 'PLN',
  /** Paraguayan Guarani */
  PYG = 'PYG',
  /** Qatari Rials */
  QAR = 'QAR',
  /** Romanian Leu */
  RON = 'RON',
  /** Russian Ruble */
  RUB = 'RUB',
  /** Saudi Arabian Riyal */
  SAR = 'SAR',
  /** Swedish Krona */
  SEK = 'SEK',
  /** Singapore Dollar */
  SGD = 'SGD',
  /** Thai Baht */
  THB = 'THB',
  /** Turkish Lira */
  TRY = 'TRY',
  /** Taiwan Dollar */
  TWD = 'TWD',
  /** United States Dollar */
  USD = 'USD',
  /** Uruguay Peso */
  UYU = 'UYU',
  /** Venezuelan Bolivar */
  VEF = 'VEF',
  /** Vietnamese Dong */
  VND = 'VND',
  /** South African Rand */
  ZAR = 'ZAR'
}

export type FacebookCurrencyFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<FacebookCurrency>>;
};

/** Timezones supported by Facebook, mapped to their corresponding IDs. */
export enum FacebookTimezone {
  /** Africa/Abidjan */
  AFRICA_ABIDJAN = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AFRICA_ACCRA = 'AFRICA_ACCRA',
  /** Africa/Addis Ababa */
  AFRICA_ADDIS_ABABA = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AFRICA_ALGIERS = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AFRICA_ASMARA = 'AFRICA_ASMARA',
  /** Africa/Bamako */
  AFRICA_BAMAKO = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AFRICA_BANGUI = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AFRICA_BANJUL = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AFRICA_BISSAU = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AFRICA_BLANTYRE = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AFRICA_BRAZZAVILLE = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AFRICA_BUJUMBURA = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AFRICA_CAIRO = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AFRICA_CASABLANCA = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AFRICA_CEUTA = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AFRICA_CONAKRY = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AFRICA_DAKAR = 'AFRICA_DAKAR',
  /** Africa/Dar Es Salaam */
  AFRICA_DAR_ES_SALAAM = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AFRICA_DJIBOUTI = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AFRICA_DOUALA = 'AFRICA_DOUALA',
  /** Africa/El Aaiun */
  AFRICA_EL_AAIUN = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AFRICA_FREETOWN = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AFRICA_GABORONE = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AFRICA_HARARE = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AFRICA_JOHANNESBURG = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AFRICA_JUBA = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AFRICA_KAMPALA = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AFRICA_KHARTOUM = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AFRICA_KIGALI = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AFRICA_KINSHASA = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AFRICA_LAGOS = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AFRICA_LIBREVILLE = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AFRICA_LOME = 'AFRICA_LOME',
  /** Africa/Luanda */
  AFRICA_LUANDA = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AFRICA_LUBUMBASHI = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AFRICA_LUSAKA = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AFRICA_MALABO = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AFRICA_MAPUTO = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AFRICA_MASERU = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AFRICA_MBABANE = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AFRICA_MOGADISHU = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AFRICA_MONROVIA = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AFRICA_NAIROBI = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AFRICA_NDJAMENA = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AFRICA_NIAMEY = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AFRICA_NOUAKCHOTT = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AFRICA_OUAGADOUGOU = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto Novo */
  AFRICA_PORTO_NOVO = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao Tome */
  AFRICA_SAO_TOME = 'AFRICA_SAO_TOME',
  /** Africa/Tripoli */
  AFRICA_TRIPOLI = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AFRICA_TUNIS = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AFRICA_WINDHOEK = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AMERICA_ADAK = 'AMERICA_ADAK',
  /** America/Anchorage */
  AMERICA_ANCHORAGE = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AMERICA_ANGUILLA = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AMERICA_ANTIGUA = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AMERICA_ARAGUAINA = 'AMERICA_ARAGUAINA',
  /** America/Argentina Buenos Aires */
  AMERICA_ARGENTINA_BUENOS_AIRES = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina Catamarca */
  AMERICA_ARGENTINA_CATAMARCA = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina Cordoba */
  AMERICA_ARGENTINA_CORDOBA = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina Jujuy */
  AMERICA_ARGENTINA_JUJUY = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina La Rioja */
  AMERICA_ARGENTINA_LA_RIOJA = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina Mendoza */
  AMERICA_ARGENTINA_MENDOZA = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina Rio Gallegos */
  AMERICA_ARGENTINA_RIO_GALLEGOS = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina Salta */
  AMERICA_ARGENTINA_SALTA = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina San Juan */
  AMERICA_ARGENTINA_SAN_JUAN = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina San Luis */
  AMERICA_ARGENTINA_SAN_LUIS = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina Tucuman */
  AMERICA_ARGENTINA_TUCUMAN = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina Ushuaia */
  AMERICA_ARGENTINA_USHUAIA = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AMERICA_ARUBA = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AMERICA_ASUNCION = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AMERICA_ATIKOKAN = 'AMERICA_ATIKOKAN',
  /** America/Bahia */
  AMERICA_BAHIA = 'AMERICA_BAHIA',
  /** America/Bahia Banderas */
  AMERICA_BAHIA_BANDERAS = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AMERICA_BARBADOS = 'AMERICA_BARBADOS',
  /** America/Belem */
  AMERICA_BELEM = 'AMERICA_BELEM',
  /** America/Belize */
  AMERICA_BELIZE = 'AMERICA_BELIZE',
  /** America/Blanc Sablon */
  AMERICA_BLANC_SABLON = 'AMERICA_BLANC_SABLON',
  /** America/Boa Vista */
  AMERICA_BOA_VISTA = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AMERICA_BOGOTA = 'AMERICA_BOGOTA',
  /** America/Boise */
  AMERICA_BOISE = 'AMERICA_BOISE',
  /** America/Cambridge Bay */
  AMERICA_CAMBRIDGE_BAY = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo Grande */
  AMERICA_CAMPO_GRANDE = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AMERICA_CANCUN = 'AMERICA_CANCUN',
  /** America/Caracas */
  AMERICA_CARACAS = 'AMERICA_CARACAS',
  /** America/Cayenne */
  AMERICA_CAYENNE = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AMERICA_CAYMAN = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AMERICA_CHICAGO = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AMERICA_CHIHUAHUA = 'AMERICA_CHIHUAHUA',
  /** America/Costa Rica */
  AMERICA_COSTA_RICA = 'AMERICA_COSTA_RICA',
  /** America/Creston */
  AMERICA_CRESTON = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AMERICA_CUIABA = 'AMERICA_CUIABA',
  /** America/Curacao */
  AMERICA_CURACAO = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AMERICA_DANMARKSHAVN = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AMERICA_DAWSON = 'AMERICA_DAWSON',
  /** America/Dawson Creek */
  AMERICA_DAWSON_CREEK = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AMERICA_DENVER = 'AMERICA_DENVER',
  /** America/Detroit */
  AMERICA_DETROIT = 'AMERICA_DETROIT',
  /** America/Dominica */
  AMERICA_DOMINICA = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AMERICA_EDMONTON = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AMERICA_EIRUNEPE = 'AMERICA_EIRUNEPE',
  /** America/El Salvador */
  AMERICA_EL_SALVADOR = 'AMERICA_EL_SALVADOR',
  /** America/Fortaleza */
  AMERICA_FORTALEZA = 'AMERICA_FORTALEZA',
  /** America/Fort Nelson */
  AMERICA_FORT_NELSON = 'AMERICA_FORT_NELSON',
  /** America/Glace Bay */
  AMERICA_GLACE_BAY = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AMERICA_GODTHAB = 'AMERICA_GODTHAB',
  /** America/Goose Bay */
  AMERICA_GOOSE_BAY = 'AMERICA_GOOSE_BAY',
  /** America/Grand Turk */
  AMERICA_GRAND_TURK = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AMERICA_GRENADA = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AMERICA_GUADELOUPE = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AMERICA_GUATEMALA = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AMERICA_GUAYAQUIL = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AMERICA_GUYANA = 'AMERICA_GUYANA',
  /** America/Halifax */
  AMERICA_HALIFAX = 'AMERICA_HALIFAX',
  /** America/Havana */
  AMERICA_HAVANA = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AMERICA_HERMOSILLO = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AMERICA_INDIANAPOLIS = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana Indianapolis */
  AMERICA_INDIANA_INDIANAPOLIS = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana Knox */
  AMERICA_INDIANA_KNOX = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana Marengo */
  AMERICA_INDIANA_MARENGO = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana Petersburg */
  AMERICA_INDIANA_PETERSBURG = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana Tell City */
  AMERICA_INDIANA_TELL_CITY = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana Vevay */
  AMERICA_INDIANA_VEVAY = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana Vincennes */
  AMERICA_INDIANA_VINCENNES = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana Winamac */
  AMERICA_INDIANA_WINAMAC = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AMERICA_INUVIK = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AMERICA_IQALUIT = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AMERICA_JAMAICA = 'AMERICA_JAMAICA',
  /** America/Juneau */
  AMERICA_JUNEAU = 'AMERICA_JUNEAU',
  /** America/Kentucky Louisville */
  AMERICA_KENTUCKY_LOUISVILLE = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky Monticello */
  AMERICA_KENTUCKY_MONTICELLO = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Kralendijk */
  AMERICA_KRALENDIJK = 'AMERICA_KRALENDIJK',
  /** America/La Paz */
  AMERICA_LA_PAZ = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AMERICA_LIMA = 'AMERICA_LIMA',
  /** America/Los Angeles */
  AMERICA_LOS_ANGELES = 'AMERICA_LOS_ANGELES',
  /** America/Lower Princes */
  AMERICA_LOWER_PRINCES = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AMERICA_MACEIO = 'AMERICA_MACEIO',
  /** America/Managua */
  AMERICA_MANAGUA = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AMERICA_MANAUS = 'AMERICA_MANAUS',
  /** America/Marigot */
  AMERICA_MARIGOT = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AMERICA_MARTINIQUE = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AMERICA_MATAMOROS = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AMERICA_MAZATLAN = 'AMERICA_MAZATLAN',
  /** America/Menominee */
  AMERICA_MENOMINEE = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AMERICA_MERIDA = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AMERICA_METLAKATLA = 'AMERICA_METLAKATLA',
  /** America/Mexico City */
  AMERICA_MEXICO_CITY = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AMERICA_MIQUELON = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AMERICA_MONCTON = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AMERICA_MONTERREY = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AMERICA_MONTEVIDEO = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AMERICA_MONTREAL = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AMERICA_MONTSERRAT = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AMERICA_NASSAU = 'AMERICA_NASSAU',
  /** America/New York */
  AMERICA_NEW_YORK = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AMERICA_NIPIGON = 'AMERICA_NIPIGON',
  /** America/Nome */
  AMERICA_NOME = 'AMERICA_NOME',
  /** America/Noronha */
  AMERICA_NORONHA = 'AMERICA_NORONHA',
  /** America/North Dakota Beulah */
  AMERICA_NORTH_DAKOTA_BEULAH = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North Dakota Center */
  AMERICA_NORTH_DAKOTA_CENTER = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North Dakota New Salem */
  AMERICA_NORTH_DAKOTA_NEW_SALEM = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AMERICA_NUUK = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AMERICA_OJINAGA = 'AMERICA_OJINAGA',
  /** America/Panama */
  AMERICA_PANAMA = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AMERICA_PANGNIRTUNG = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AMERICA_PARAMARIBO = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AMERICA_PHOENIX = 'AMERICA_PHOENIX',
  /** America/Porto Velho */
  AMERICA_PORTO_VELHO = 'AMERICA_PORTO_VELHO',
  /** America/Port Au Prince */
  AMERICA_PORT_AU_PRINCE = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port Of Spain */
  AMERICA_PORT_OF_SPAIN = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto Rico */
  AMERICA_PUERTO_RICO = 'AMERICA_PUERTO_RICO',
  /** America/Punta Arenas */
  AMERICA_PUNTA_ARENAS = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy River */
  AMERICA_RAINY_RIVER = 'AMERICA_RAINY_RIVER',
  /** America/Rankin Inlet */
  AMERICA_RANKIN_INLET = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AMERICA_RECIFE = 'AMERICA_RECIFE',
  /** America/Regina */
  AMERICA_REGINA = 'AMERICA_REGINA',
  /** America/Resolute */
  AMERICA_RESOLUTE = 'AMERICA_RESOLUTE',
  /** America/Rio Branco */
  AMERICA_RIO_BRANCO = 'AMERICA_RIO_BRANCO',
  /** America/Santarem */
  AMERICA_SANTAREM = 'AMERICA_SANTAREM',
  /** America/Santiago */
  AMERICA_SANTIAGO = 'AMERICA_SANTIAGO',
  /** America/Santo Domingo */
  AMERICA_SANTO_DOMINGO = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao Paulo */
  AMERICA_SAO_PAULO = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AMERICA_SCORESBYSUND = 'AMERICA_SCORESBYSUND',
  /** America/Sitka */
  AMERICA_SITKA = 'AMERICA_SITKA',
  /** America/St Barthelemy */
  AMERICA_ST_BARTHELEMY = 'AMERICA_ST_BARTHELEMY',
  /** America/St Johns */
  AMERICA_ST_JOHNS = 'AMERICA_ST_JOHNS',
  /** America/St Kitts */
  AMERICA_ST_KITTS = 'AMERICA_ST_KITTS',
  /** America/St Lucia */
  AMERICA_ST_LUCIA = 'AMERICA_ST_LUCIA',
  /** America/St Thomas */
  AMERICA_ST_THOMAS = 'AMERICA_ST_THOMAS',
  /** America/St Vincent */
  AMERICA_ST_VINCENT = 'AMERICA_ST_VINCENT',
  /** America/Swift Current */
  AMERICA_SWIFT_CURRENT = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AMERICA_TEGUCIGALPA = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AMERICA_THULE = 'AMERICA_THULE',
  /** America/Thunder Bay */
  AMERICA_THUNDER_BAY = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AMERICA_TIJUANA = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AMERICA_TORONTO = 'AMERICA_TORONTO',
  /** America/Tortola */
  AMERICA_TORTOLA = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AMERICA_VANCOUVER = 'AMERICA_VANCOUVER',
  /** America/Whitehorse */
  AMERICA_WHITEHORSE = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AMERICA_WINNIPEG = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AMERICA_YAKUTAT = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AMERICA_YELLOWKNIFE = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  ANTARCTICA_CASEY = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  ANTARCTICA_DAVIS = 'ANTARCTICA_DAVIS',
  /** Antarctica/Dumontdurville */
  ANTARCTICA_DUMONTDURVILLE = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  ANTARCTICA_MACQUARIE = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  ANTARCTICA_MAWSON = 'ANTARCTICA_MAWSON',
  /** Antarctica/Mcmurdo */
  ANTARCTICA_MCMURDO = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  ANTARCTICA_PALMER = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  ANTARCTICA_ROTHERA = 'ANTARCTICA_ROTHERA',
  /** Antarctica/Syowa */
  ANTARCTICA_SYOWA = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  ANTARCTICA_TROLL = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  ANTARCTICA_VOSTOK = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ARCTIC_LONGYEARBYEN = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  ASIA_ADEN = 'ASIA_ADEN',
  /** Asia/Almaty */
  ASIA_ALMATY = 'ASIA_ALMATY',
  /** Asia/Amman */
  ASIA_AMMAN = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  ASIA_ANADYR = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  ASIA_AQTAU = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  ASIA_AQTOBE = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  ASIA_ASHGABAT = 'ASIA_ASHGABAT',
  /** Asia/Atyrau */
  ASIA_ATYRAU = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  ASIA_BAGHDAD = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  ASIA_BAHRAIN = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  ASIA_BAKU = 'ASIA_BAKU',
  /** Asia/Bangkok */
  ASIA_BANGKOK = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  ASIA_BARNAUL = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  ASIA_BEIRUT = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  ASIA_BISHKEK = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  ASIA_BRUNEI = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  ASIA_CALCUTTA = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  ASIA_CHITA = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  ASIA_CHOIBALSAN = 'ASIA_CHOIBALSAN',
  /** Asia/Colombo */
  ASIA_COLOMBO = 'ASIA_COLOMBO',
  /** Asia/Damascus */
  ASIA_DAMASCUS = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  ASIA_DHAKA = 'ASIA_DHAKA',
  /** Asia/Dili */
  ASIA_DILI = 'ASIA_DILI',
  /** Asia/Dubai */
  ASIA_DUBAI = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  ASIA_DUSHANBE = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  ASIA_FAMAGUSTA = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  ASIA_GAZA = 'ASIA_GAZA',
  /** Asia/Hebron */
  ASIA_HEBRON = 'ASIA_HEBRON',
  /** Asia/Hong Kong */
  ASIA_HONG_KONG = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  ASIA_HOVD = 'ASIA_HOVD',
  /** Asia/Ho Chi Minh */
  ASIA_HO_CHI_MINH = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  ASIA_IRKUTSK = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  ASIA_ISTANBUL = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  ASIA_JAKARTA = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  ASIA_JAYAPURA = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  ASIA_JERUSALEM = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  ASIA_KABUL = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  ASIA_KAMCHATKA = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  ASIA_KARACHI = 'ASIA_KARACHI',
  /** Asia/Kathmandu */
  ASIA_KATHMANDU = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  ASIA_KATMANDU = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  ASIA_KHANDYGA = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  ASIA_KOLKATA = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  ASIA_KRASNOYARSK = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala Lumpur */
  ASIA_KUALA_LUMPUR = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  ASIA_KUCHING = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  ASIA_KUWAIT = 'ASIA_KUWAIT',
  /** Asia/Macau */
  ASIA_MACAU = 'ASIA_MACAU',
  /** Asia/Magadan */
  ASIA_MAGADAN = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  ASIA_MAKASSAR = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  ASIA_MANILA = 'ASIA_MANILA',
  /** Asia/Muscat */
  ASIA_MUSCAT = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  ASIA_NICOSIA = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  ASIA_NOVOKUZNETSK = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  ASIA_NOVOSIBIRSK = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  ASIA_OMSK = 'ASIA_OMSK',
  /** Asia/Oral */
  ASIA_ORAL = 'ASIA_ORAL',
  /** Asia/Phnom Penh */
  ASIA_PHNOM_PENH = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  ASIA_PONTIANAK = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  ASIA_PYONGYANG = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  ASIA_QATAR = 'ASIA_QATAR',
  /** Asia/Qostanay */
  ASIA_QOSTANAY = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  ASIA_QYZYLORDA = 'ASIA_QYZYLORDA',
  /** Asia/Riyadh */
  ASIA_RIYADH = 'ASIA_RIYADH',
  /** Asia/Sakhalin */
  ASIA_SAKHALIN = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  ASIA_SAMARKAND = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  ASIA_SEOUL = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  ASIA_SHANGHAI = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  ASIA_SINGAPORE = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  ASIA_SREDNEKOLYMSK = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  ASIA_TAIPEI = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  ASIA_TASHKENT = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  ASIA_TBILISI = 'ASIA_TBILISI',
  /** Asia/Tehran */
  ASIA_TEHRAN = 'ASIA_TEHRAN',
  /** Asia/Thimphu */
  ASIA_THIMPHU = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  ASIA_TOKYO = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  ASIA_TOMSK = 'ASIA_TOMSK',
  /** Asia/Ulaanbaatar */
  ASIA_ULAANBAATAR = 'ASIA_ULAANBAATAR',
  /** Asia/Urumqi */
  ASIA_URUMQI = 'ASIA_URUMQI',
  /** Asia/Ust Nera */
  ASIA_UST_NERA = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  ASIA_VIENTIANE = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  ASIA_VLADIVOSTOK = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  ASIA_YAKUTSK = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  ASIA_YANGON = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  ASIA_YEKATERINBURG = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  ASIA_YEREVAN = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  ATLANTIC_AZORES = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  ATLANTIC_BERMUDA = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  ATLANTIC_CANARY = 'ATLANTIC_CANARY',
  /** Atlantic/Cape Verde */
  ATLANTIC_CAPE_VERDE = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faroe */
  ATLANTIC_FAROE = 'ATLANTIC_FAROE',
  /** Atlantic/Madeira */
  ATLANTIC_MADEIRA = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  ATLANTIC_REYKJAVIK = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South Georgia */
  ATLANTIC_SOUTH_GEORGIA = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  ATLANTIC_STANLEY = 'ATLANTIC_STANLEY',
  /** Atlantic/St Helena */
  ATLANTIC_ST_HELENA = 'ATLANTIC_ST_HELENA',
  /** Australia/Adelaide */
  AUSTRALIA_ADELAIDE = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AUSTRALIA_BRISBANE = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken Hill */
  AUSTRALIA_BROKEN_HILL = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Currie */
  AUSTRALIA_CURRIE = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AUSTRALIA_DARWIN = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AUSTRALIA_EUCLA = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AUSTRALIA_HOBART = 'AUSTRALIA_HOBART',
  /** Australia/Lindeman */
  AUSTRALIA_LINDEMAN = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord Howe */
  AUSTRALIA_LORD_HOWE = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AUSTRALIA_MELBOURNE = 'AUSTRALIA_MELBOURNE',
  /** Australia/Perth */
  AUSTRALIA_PERTH = 'AUSTRALIA_PERTH',
  /** Australia/Sydney */
  AUSTRALIA_SYDNEY = 'AUSTRALIA_SYDNEY',
  /** CET */
  CET = 'CET',
  /** CST6CDT */
  CST6CDT = 'CST6CDT',
  /** EET */
  EET = 'EET',
  /** EST */
  EST = 'EST',
  /** EST5EDT */
  EST5EDT = 'EST5EDT',
  /** Etc/GMT */
  ETC_GMT = 'ETC_GMT',
  /** Etc/GMT 0 */
  ETC_GMT0 = 'ETC_GMT0',
  /** Etc/GMT minus 0 */
  ETC_GMT_MINUS_0 = 'ETC_GMT_MINUS_0',
  /** Etc/GMT minus 1 */
  ETC_GMT_MINUS_1 = 'ETC_GMT_MINUS_1',
  /** Etc/GMT minus 2 */
  ETC_GMT_MINUS_2 = 'ETC_GMT_MINUS_2',
  /** Etc/GMT minus 3 */
  ETC_GMT_MINUS_3 = 'ETC_GMT_MINUS_3',
  /** Etc/GMT minus 4 */
  ETC_GMT_MINUS_4 = 'ETC_GMT_MINUS_4',
  /** Etc/GMT minus 5 */
  ETC_GMT_MINUS_5 = 'ETC_GMT_MINUS_5',
  /** Etc/GMT minus 6 */
  ETC_GMT_MINUS_6 = 'ETC_GMT_MINUS_6',
  /** Etc/GMT minus 7 */
  ETC_GMT_MINUS_7 = 'ETC_GMT_MINUS_7',
  /** Etc/GMT minus 8 */
  ETC_GMT_MINUS_8 = 'ETC_GMT_MINUS_8',
  /** Etc/GMT minus 9 */
  ETC_GMT_MINUS_9 = 'ETC_GMT_MINUS_9',
  /** Etc/GMT minus 10 */
  ETC_GMT_MINUS_10 = 'ETC_GMT_MINUS_10',
  /** Etc/GMT minus 11 */
  ETC_GMT_MINUS_11 = 'ETC_GMT_MINUS_11',
  /** Etc/GMT minus 12 */
  ETC_GMT_MINUS_12 = 'ETC_GMT_MINUS_12',
  /** Etc/GMT minus 13 */
  ETC_GMT_MINUS_13 = 'ETC_GMT_MINUS_13',
  /** Etc/GMT minus 14 */
  ETC_GMT_MINUS_14 = 'ETC_GMT_MINUS_14',
  /** Etc/GMT plus 0 */
  ETC_GMT_PLUS_0 = 'ETC_GMT_PLUS_0',
  /** Etc/GMT plus 1 */
  ETC_GMT_PLUS_1 = 'ETC_GMT_PLUS_1',
  /** Etc/GMT plus 2 */
  ETC_GMT_PLUS_2 = 'ETC_GMT_PLUS_2',
  /** Etc/GMT plus 3 */
  ETC_GMT_PLUS_3 = 'ETC_GMT_PLUS_3',
  /** Etc/GMT plus 4 */
  ETC_GMT_PLUS_4 = 'ETC_GMT_PLUS_4',
  /** Etc/GMT plus 5 */
  ETC_GMT_PLUS_5 = 'ETC_GMT_PLUS_5',
  /** Etc/GMT plus 6 */
  ETC_GMT_PLUS_6 = 'ETC_GMT_PLUS_6',
  /** Etc/GMT plus 7 */
  ETC_GMT_PLUS_7 = 'ETC_GMT_PLUS_7',
  /** Etc/GMT plus 8 */
  ETC_GMT_PLUS_8 = 'ETC_GMT_PLUS_8',
  /** Etc/GMT plus 9 */
  ETC_GMT_PLUS_9 = 'ETC_GMT_PLUS_9',
  /** Etc/GMT plus 10 */
  ETC_GMT_PLUS_10 = 'ETC_GMT_PLUS_10',
  /** Etc/GMT plus 11 */
  ETC_GMT_PLUS_11 = 'ETC_GMT_PLUS_11',
  /** Etc/GMT plus 12 */
  ETC_GMT_PLUS_12 = 'ETC_GMT_PLUS_12',
  /** ETC/Greenwich */
  ETC_GREENWICH = 'ETC_GREENWICH',
  /** ETC/Universal */
  ETC_UNIVERSAL = 'ETC_UNIVERSAL',
  /** ETC/Zulu */
  ETC_ZULU = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EUROPE_AMSTERDAM = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EUROPE_ANDORRA = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EUROPE_ASTRAKHAN = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EUROPE_ATHENS = 'EUROPE_ATHENS',
  /** Europe/Belgrade */
  EUROPE_BELGRADE = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EUROPE_BERLIN = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EUROPE_BRATISLAVA = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EUROPE_BRUSSELS = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EUROPE_BUCHAREST = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EUROPE_BUDAPEST = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EUROPE_BUSINGEN = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EUROPE_CHISINAU = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EUROPE_COPENHAGEN = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EUROPE_DUBLIN = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EUROPE_GIBRALTAR = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EUROPE_GUERNSEY = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EUROPE_HELSINKI = 'EUROPE_HELSINKI',
  /** Europe/Isle Of Man */
  EUROPE_ISLE_OF_MAN = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EUROPE_ISTANBUL = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EUROPE_JERSEY = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EUROPE_KALININGRAD = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EUROPE_KIEV = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EUROPE_KIROV = 'EUROPE_KIROV',
  /** Europe/Lisbon */
  EUROPE_LISBON = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EUROPE_LJUBLJANA = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EUROPE_LONDON = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EUROPE_LUXEMBOURG = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EUROPE_MADRID = 'EUROPE_MADRID',
  /** Europe/Malta */
  EUROPE_MALTA = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EUROPE_MARIEHAMN = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EUROPE_MINSK = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EUROPE_MONACO = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EUROPE_MOSCOW = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EUROPE_NICOSIA = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EUROPE_OSLO = 'EUROPE_OSLO',
  /** Europe/Paris */
  EUROPE_PARIS = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EUROPE_PODGORICA = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EUROPE_PRAGUE = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EUROPE_RIGA = 'EUROPE_RIGA',
  /** Europe/Rome */
  EUROPE_ROME = 'EUROPE_ROME',
  /** Europe/Samara */
  EUROPE_SAMARA = 'EUROPE_SAMARA',
  /** Europe/San Marino */
  EUROPE_SAN_MARINO = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EUROPE_SARAJEVO = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EUROPE_SARATOV = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EUROPE_SIMFEROPOL = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EUROPE_SKOPJE = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EUROPE_SOFIA = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EUROPE_STOCKHOLM = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EUROPE_TALLINN = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EUROPE_TIRANE = 'EUROPE_TIRANE',
  /** Europe/Ulyanovsk */
  EUROPE_ULYANOVSK = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EUROPE_UZHGOROD = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EUROPE_VADUZ = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EUROPE_VATICAN = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EUROPE_VIENNA = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EUROPE_VILNIUS = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EUROPE_VOLGOGRAD = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EUROPE_WARSAW = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EUROPE_ZAGREB = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EUROPE_ZAPOROZHYE = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EUROPE_ZURICH = 'EUROPE_ZURICH',
  /** GMT */
  GMT = 'GMT',
  /** HST */
  HST = 'HST',
  /** Indian/Antananarivo */
  INDIAN_ANTANANARIVO = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  INDIAN_CHAGOS = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  INDIAN_CHRISTMAS = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  INDIAN_COCOS = 'INDIAN_COCOS',
  /** Indian/Comoro */
  INDIAN_COMORO = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  INDIAN_KERGUELEN = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  INDIAN_MAHE = 'INDIAN_MAHE',
  /** Indian/Maldives */
  INDIAN_MALDIVES = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  INDIAN_MAURITIUS = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  INDIAN_MAYOTTE = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  INDIAN_REUNION = 'INDIAN_REUNION',
  /** MET */
  MET = 'MET',
  /** MST */
  MST = 'MST',
  /** MST7MDT */
  MST7MDT = 'MST7MDT',
  /** Pacific/Apia */
  PACIFIC_APIA = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PACIFIC_AUCKLAND = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PACIFIC_BOUGAINVILLE = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PACIFIC_CHATHAM = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PACIFIC_CHUUK = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PACIFIC_EASTER = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PACIFIC_EFATE = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PACIFIC_ENDERBURY = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PACIFIC_FAKAOFO = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PACIFIC_FIJI = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PACIFIC_FUNAFUTI = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PACIFIC_GALAPAGOS = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PACIFIC_GAMBIER = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PACIFIC_GUADALCANAL = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PACIFIC_GUAM = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PACIFIC_HONOLULU = 'PACIFIC_HONOLULU',
  /** Pacific/Kiritimati */
  PACIFIC_KIRITIMATI = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PACIFIC_KOSRAE = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PACIFIC_KWAJALEIN = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PACIFIC_MAJURO = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PACIFIC_MARQUESAS = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PACIFIC_MIDWAY = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PACIFIC_NAURU = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PACIFIC_NIUE = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PACIFIC_NORFOLK = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PACIFIC_NOUMEA = 'PACIFIC_NOUMEA',
  /** Pacific/Pago Pago */
  PACIFIC_PAGO_PAGO = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PACIFIC_PALAU = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PACIFIC_PITCAIRN = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PACIFIC_POHNPEI = 'PACIFIC_POHNPEI',
  /** Pacific/Port Moresby */
  PACIFIC_PORT_MORESBY = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PACIFIC_RAROTONGA = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PACIFIC_SAIPAN = 'PACIFIC_SAIPAN',
  /** Pacific/Tahiti */
  PACIFIC_TAHITI = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PACIFIC_TARAWA = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PACIFIC_TONGATAPU = 'PACIFIC_TONGATAPU',
  /** Pacific/Wake */
  PACIFIC_WAKE = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PACIFIC_WALLIS = 'PACIFIC_WALLIS',
  /** PST8PDT */
  PST8PDT = 'PST8PDT',
  /** Unknown */
  UNKNOWN = 'UNKNOWN',
  /** UTC */
  UTC = 'UTC',
  /** WET */
  WET = 'WET'
}

export type FacebookTimezoneFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<ExternalAdAccountStatus>>;
};

export type FbCurrency = {
  __typename?: 'FbCurrency';
  facebookCurrency: Scalars['String'];
  facebookCurrencyMinValue: Scalars['Float'];
  facebookCurrencyOffset: Scalars['Int'];
  facebookCurrencySymbol: Scalars['String'];
};

export type FbCurrencyCursored = {
  __typename?: 'FbCurrencyCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<FbCurrency>>;
};

export type FbCurrencyFilter = {
  facebookCurrency?: InputMaybe<Scalars['String']>;
  facebookCurrencyOffset?: InputMaybe<Scalars['Int']>;
  facebookCurrencySymbol?: InputMaybe<Scalars['String']>;
};

/** Facebook user */
export type FbUser = {
  __typename?: 'FbUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FbUserFilter = {
  accessToken: Scalars['String'];
  jwt?: InputMaybe<Scalars['Int']>;
};

export type FloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Float']>;
};

export type IdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['ID']>;
};

export type ImportSetting = {
  __typename?: 'ImportSetting';
  currency: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: ImportSettingEntityType;
  settings?: Maybe<Array<ImportSettingNameValue>>;
};

export type ImportSettingCurrencyFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<Scalars['String']>>;
};

export enum ImportSettingEntityType {
  BUSINESS = 'BUSINESS',
  GLOBAL = 'GLOBAL',
  INVOICE_GROUP = 'INVOICE_GROUP'
}

export type ImportSettingEntityTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<ImportSettingEntityType>>;
};

export type ImportSettingFilters = {
  currency?: InputMaybe<Array<ImportSettingCurrencyFilter>>;
  entityId?: InputMaybe<Array<IdFilter>>;
  entityType?: InputMaybe<Array<ImportSettingEntityTypeFilter>>;
  settingName?: InputMaybe<Array<ImportSettingNameFilter>>;
  settingValue?: InputMaybe<Array<StringFilter>>;
};

export enum ImportSettingName {
  ACCOUNT_TYPE = 'ACCOUNT_TYPE',
  MAX_SPEND_CAP = 'MAX_SPEND_CAP',
  MIN_SPEND_CAP = 'MIN_SPEND_CAP',
  SPEND_FACTOR = 'SPEND_FACTOR'
}

export type ImportSettingNameFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<ImportSettingName>>;
};

export type ImportSettingNameValue = {
  __typename?: 'ImportSettingNameValue';
  settingName: ImportSettingName;
  settingValue?: Maybe<Scalars['String']>;
};

export type ImportSettingsCursored = {
  __typename?: 'ImportSettingsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ImportSetting>>;
};

export type IntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Int']>;
};

export type Locale = {
  __typename?: 'Locale';
  currencySymbol?: Maybe<Scalars['String']>;
  decimalPoint?: Maybe<Scalars['String']>;
  fractionalDigits?: Maybe<Scalars['Int']>;
  grouping?: Maybe<Array<Scalars['Int']>>;
  internationalCurrencySymbol?: Maybe<Scalars['String']>;
  internationalFractionalDigits?: Maybe<Scalars['Int']>;
  monetaryDecimalPoint?: Maybe<Scalars['String']>;
  monetaryGrouping?: Maybe<Array<Scalars['Int']>>;
  monetaryThousandsSeparator?: Maybe<Scalars['String']>;
  negativeCurrencySymbolPrecedes?: Maybe<Scalars['Boolean']>;
  negativeSeparatedBySpace?: Maybe<Scalars['Boolean']>;
  negativeSign?: Maybe<Scalars['String']>;
  negativeSignPosition?: Maybe<Scalars['Int']>;
  positiveCurrencySymbolPrecedes?: Maybe<Scalars['Boolean']>;
  positiveSeparatedBySpace?: Maybe<Scalars['Boolean']>;
  positiveSign?: Maybe<Scalars['String']>;
  positiveSignPosition?: Maybe<Scalars['Int']>;
  thousandsSeparator?: Maybe<Scalars['String']>;
};

export type LocaleMetadata = {
  __typename?: 'LocaleMetadata';
  culture?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  timezone?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExternalAdAccountToInvoiceGroup?: Maybe<ExternalAdAccount>;
  authorizeAdminExternalAdvertiser?: Maybe<kvsKey>;
  authorizeExternalAdvertiser?: Maybe<kvsKey>;
  createAdminUser?: Maybe<AdminUser>;
  createCustomer: Customer;
  createCustomerNotice: CustomerNotice;
  createDeposit?: Maybe<Deposit>;
  createExtendedCreditInvoiceGroup?: Maybe<ExtendedCreditInvoiceGroup>;
  /**  Create a new ad account on Facebook. This action is not reversible, any new external ad account can only be disabled. */
  createExternalAdAccount?: Maybe<ExternalAdAccount>;
  createReport: Report;
  createSmsapiDutySchedule?: Maybe<Array<Maybe<SMSApiDutySchedule>>>;
  createSmsapiMessage: SMSApiMessage;
  createUser: User;
  createWithdraw?: Maybe<Withdraw>;
  deleteCreditSettings: Scalars['Boolean'];
  deleteExtendedCreditInvoiceGroup?: Maybe<Scalars['Boolean']>;
  /**  Delete import setting and return remaining settings for given entity  */
  deleteImportSetting?: Maybe<ImportSetting>;
  disableFbAdAccountStats?: Maybe<ExternalAdAccount>;
  email?: Maybe<Array<QueueEmail>>;
  insertCreditSettingsTransaction: CreditSetting;
  markCustomerNoticeRead: CustomerNotice;
  /**  Re-import Facebook ad accounts with fresh data from Facebook's API.  */
  refreshExternalAdAccounts?: Maybe<Array<ExternalAdAccount>>;
  removeExternalAdAccountFromInvoiceGroup?: Maybe<ExternalAdAccount>;
  transferExternalAdAccountFunds: TransactionExternal;
  updateAdminUser?: Maybe<AdminUser>;
  updateBusinessEmailRecipients?: Maybe<BusinessEmailRecipientsCursored>;
  updateCreditLimitLog?: Maybe<Scalars['Boolean']>;
  updateCreditSettings: CreditSetting;
  updateCustomer: Customer;
  updateDeposit?: Maybe<Deposit>;
  updateExtendedCreditInvoiceGroup?: Maybe<ExtendedCreditInvoiceGroup>;
  /**  Update an external ad account in database.  */
  updateExternalAdAccount?: Maybe<ExternalAdAccount>;
  /** Update an external Facebook ad account's agencies. Agencies with empty permitted tasks will be removed. */
  updateExternalAdAccountAgencies: Array<ExternalAdAccountAgency>;
  /**  Update external ad account assigned users.  */
  updateExternalAdAccountAssignedUsers?: Maybe<Array<Maybe<ExternalAdAccountAssignedUser>>>;
  /**  Create or update import setting and return all settings for given entity  */
  updateImportSetting: ImportSetting;
  updateReport: Report;
  updateSmsapiDutySchedule?: Maybe<Array<Maybe<SMSApiDutySchedule>>>;
  /**  Update spend can on external ad accounts for external advertiser id with Facebook's API.  */
  updateSpendCap: ExternalAdAccount;
  updateUser: User;
  /** Used for changing funds in wallet */
  updateWalletFunds: Wallet;
  uploadProfileImage?: Maybe<Array<Maybe<UploadProfileImage>>>;
  version?: Maybe<Scalars['String']>;
};


export type MutationaddExternalAdAccountToInvoiceGroupArgs = {
  extendedCreditInvoiceGroupId: Scalars['ID'];
  externalAdAccountId: Scalars['ID'];
};


export type MutationauthorizeAdminExternalAdvertiserArgs = {
  code: Scalars['String'];
  data?: InputMaybe<SSOUser>;
  sessionId?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};


export type MutationauthorizeExternalAdvertiserArgs = {
  code: Scalars['String'];
  data?: InputMaybe<SSOUser>;
  sessionId?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};


export type MutationcreateAdminUserArgs = {
  adminUserCredentials: Array<InputMaybe<CredentialInput>>;
  adminUserEmail: Scalars['Email'];
  adminUserFbEmail?: InputMaybe<Scalars['Email']>;
  adminUserHasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  adminUserLogin: Scalars['String'];
  adminUserName: Scalars['String'];
  adminUserPassword: Scalars['String'];
  adminUserPhone?: InputMaybe<Scalars['String']>;
  adminUserSurname: Scalars['String'];
  permittedExternalAdvertisers?: InputMaybe<Array<InputMaybe<PermittedExternalAdvertiser>>>;
};


export type MutationcreateCustomerArgs = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  bankTotalAmount?: InputMaybe<Scalars['String']>;
  bankType?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['ID']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerContractSigned?: InputMaybe<Scalars['Boolean']>;
  customerCountryId: Scalars['String'];
  customerEmail: Scalars['String'];
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerIsFullyRegistered?: InputMaybe<Scalars['Boolean']>;
  customerIsTest?: InputMaybe<Scalars['Boolean']>;
  customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalRegNumber?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerMailSubscribed?: InputMaybe<Scalars['Boolean']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerProfileImage?: InputMaybe<Scalars['String']>;
  customerProfileImageId?: InputMaybe<Scalars['ID']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  externalAdAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  fbUserEmails?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationcreateCustomerNoticeArgs = {
  customerId: Scalars['ID'];
  customerNoticeIsMass?: InputMaybe<Scalars['Boolean']>;
  customerNoticeIsNews?: InputMaybe<Scalars['Boolean']>;
  customerNoticeIsTranslated?: InputMaybe<Scalars['Boolean']>;
  customerNoticeMessage: Scalars['String'];
  customerNoticeNoticeType: CustomerNoticeType;
  customerNoticeTitle: Scalars['String'];
};


export type MutationcreateDepositArgs = {
  bankId: Scalars['ID'];
  depositAmount: Scalars['Float'];
  depositDescription?: InputMaybe<Scalars['String']>;
  depositPaymentType: PaymentType;
};


export type MutationcreateExtendedCreditInvoiceGroupArgs = {
  extendedCreditId?: InputMaybe<Scalars['ID']>;
  extendedCreditInvoiceGroupEmails?: InputMaybe<Array<Scalars['Email']>>;
  extendedCreditInvoiceGroupName: Scalars['String'];
};


export type MutationcreateExternalAdAccountArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  endAdvertiserId: Scalars['String'];
  extendedCreditId?: InputMaybe<Scalars['ID']>;
  extendedCreditInvoiceGroupId?: InputMaybe<Scalars['ID']>;
  externalAdAccountCurrency: FacebookCurrency;
  externalAdAccountName: Scalars['String'];
  externalAdAccountSpendCap?: InputMaybe<Scalars['Float']>;
  externalAdAccountTimezone: FacebookTimezone;
  externalAdAccountType: AdAccountType;
  externalAdvertiserId: Scalars['ID'];
  invoice?: InputMaybe<Scalars['Boolean']>;
  invoicingEmails?: InputMaybe<Array<InputMaybe<Scalars['Email']>>>;
};


export type MutationcreateReportArgs = {
  action: ReportAction;
  conditions?: InputMaybe<Array<InputMaybe<ReportCondition>>>;
  dataset: Scalars['String'];
  date?: InputMaybe<ReportDateOption>;
  dimensions?: InputMaybe<Array<Scalars['String']>>;
  externalAdvertiserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  filters?: InputMaybe<Array<InputMaybe<ReportFilterOption>>>;
  hideZeroRows?: InputMaybe<Scalars['Boolean']>;
  language: ReportLanguage;
  metrics?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  overviewType?: InputMaybe<ReportOverview>;
  reportReady?: InputMaybe<Scalars['Boolean']>;
  schedule: ReportSchedule;
  scope?: InputMaybe<ReportScope>;
  token: Scalars['String'];
};


export type MutationcreateSmsapiDutyScheduleArgs = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  externalAdvertiserId: Scalars['ID'];
  recipients: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationcreateSmsapiMessageArgs = {
  message: Scalars['String'];
  recipients: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationcreateUserArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email: Scalars['String'];
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  tourFinished?: InputMaybe<Scalars['Boolean']>;
};


export type MutationcreateWithdrawArgs = {
  bankId: Scalars['ID'];
  withdrawAmount: Scalars['Float'];
  withdrawDescription: Scalars['String'];
  withdrawStatus?: InputMaybe<TransactionStatus>;
};


export type MutationdeleteCreditSettingsArgs = {
  entityId: Scalars['ID'];
  entityType: Scalars['String'];
};


export type MutationdeleteExtendedCreditInvoiceGroupArgs = {
  extendedCreditInvoiceGroupId: Scalars['ID'];
};


export type MutationdeleteImportSettingArgs = {
  currency?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: ImportSettingEntityType;
  settingName: ImportSettingName;
};


export type MutationdisableFbAdAccountStatsArgs = {
  externalAdAccountId: Scalars['ID'];
};


export type MutationemailArgs = {
  attachmentEncoding?: InputMaybe<Scalars['String']>;
  attachmentFilename?: InputMaybe<Scalars['String']>;
  attachmentMimetype?: InputMaybe<Scalars['String']>;
  attachmentPath?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  destinationCCs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  destinationEmails: Array<InputMaybe<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
  messageHtml?: InputMaybe<Scalars['String']>;
  messageTxt?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  template?: InputMaybe<Scalars['String']>;
};


export type MutationinsertCreditSettingsTransactionArgs = {
  entityId: Scalars['ID'];
  entityType: Scalars['String'];
  transactionValue: Scalars['Float'];
};


export type MutationmarkCustomerNoticeReadArgs = {
  customerNoticeId: Scalars['ID'];
  customerNoticeIsRead?: InputMaybe<Scalars['Boolean']>;
};


export type MutationrefreshExternalAdAccountsArgs = {
  externalAdAccountIds: Array<Scalars['ID']>;
};


export type MutationremoveExternalAdAccountFromInvoiceGroupArgs = {
  externalAdAccountId: Scalars['ID'];
};


export type MutationtransferExternalAdAccountFundsArgs = {
  bankId?: InputMaybe<Scalars['ID']>;
  fromExternalAdAccounts?: InputMaybe<Array<TransferExternalAdAccountInput>>;
  toExternalAdAccounts?: InputMaybe<Array<TransferExternalAdAccountInput>>;
  transactionExternalId?: InputMaybe<Scalars['ID']>;
};


export type MutationupdateAdminUserArgs = {
  adminUserCredentials?: InputMaybe<Array<InputMaybe<CredentialInput>>>;
  adminUserEmail?: InputMaybe<Scalars['Email']>;
  adminUserFbEmail?: InputMaybe<Scalars['Email']>;
  adminUserHasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  adminUserId: Scalars['ID'];
  adminUserIsDeleted?: InputMaybe<Scalars['Boolean']>;
  adminUserLogin?: InputMaybe<Scalars['String']>;
  adminUserName?: InputMaybe<Scalars['String']>;
  adminUserPassword?: InputMaybe<Scalars['String']>;
  adminUserPhone?: InputMaybe<Scalars['String']>;
  adminUserSurname?: InputMaybe<Scalars['String']>;
  permittedExternalAdvertisers?: InputMaybe<Array<InputMaybe<PermittedExternalAdvertiser>>>;
};


export type MutationupdateBusinessEmailRecipientsArgs = {
  adminUserIds: Array<InputMaybe<Scalars['ID']>>;
  adminUserNotificationType: AdminUserNotificationType;
  businessId: Scalars['ID'];
};


export type MutationupdateCreditLimitLogArgs = {
  autoRebalancedCreditLimits?: InputMaybe<Array<InputMaybe<AutoRebalancedCreditLimit>>>;
};


export type MutationupdateCreditSettingsArgs = {
  entityId: Scalars['ID'];
  entityType: Scalars['String'];
  spendCapLimit: Scalars['Float'];
};


export type MutationupdateCustomerArgs = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  bankTotalAmount?: InputMaybe<Scalars['String']>;
  bankType?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['ID']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerContractSigned?: InputMaybe<Scalars['Boolean']>;
  customerCountryId?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFullName?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerIsFullyRegistered?: InputMaybe<Scalars['Boolean']>;
  customerIsTest?: InputMaybe<Scalars['Boolean']>;
  customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalFullName?: InputMaybe<Scalars['String']>;
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalRegNumber?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerMailSubscribed?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerProfileImage?: InputMaybe<Scalars['String']>;
  customerProfileImageId?: InputMaybe<Scalars['ID']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerStatus?: InputMaybe<CustomerStatus>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  externalAdAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  fbUserEmails?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationupdateDepositArgs = {
  depositAmount?: InputMaybe<Scalars['Float']>;
  depositDescription?: InputMaybe<Scalars['String']>;
  depositId: Scalars['ID'];
  depositReferenceFinal?: InputMaybe<Scalars['String']>;
  depositStatus?: InputMaybe<TransactionStatus>;
};


export type MutationupdateExtendedCreditInvoiceGroupArgs = {
  extendedCreditInvoiceGroupEmails?: InputMaybe<Array<Scalars['Email']>>;
  extendedCreditInvoiceGroupId: Scalars['ID'];
  extendedCreditInvoiceGroupName: Scalars['String'];
};


export type MutationupdateExternalAdAccountArgs = {
  externalAdAccountId: Scalars['ID'];
  externalAdAccountMaxSpendCap?: InputMaybe<Scalars['Float']>;
  externalAdAccountMinSpendCap?: InputMaybe<Scalars['Float']>;
  externalAdAccountSpendFactor?: InputMaybe<Scalars['Float']>;
  externalAdAccountType: AdAccountType;
};


export type MutationupdateExternalAdAccountAgenciesArgs = {
  agencies: Array<InputMaybe<ExternalAdAccountAgencyInput>>;
  externalAdAccountId: Scalars['ID'];
};


export type MutationupdateExternalAdAccountAssignedUsersArgs = {
  assignedUsers?: InputMaybe<Array<InputMaybe<ExternalAdAccountAssignedUsersInput>>>;
  externalAdAccountId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationupdateImportSettingArgs = {
  currency?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: ImportSettingEntityType;
  settingName: ImportSettingName;
  settingValue?: InputMaybe<Scalars['String']>;
};


export type MutationupdateReportArgs = {
  action?: InputMaybe<ReportAction>;
  activate?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<ReportCondition>>>;
  dataset?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<ReportDateOption>;
  delete?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalAdvertiserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  filters?: InputMaybe<Array<InputMaybe<ReportFilterOption>>>;
  hideZeroRows?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ReportLanguage>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  overviewType?: InputMaybe<ReportOverview>;
  reportReady?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<ReportSchedule>;
  scope?: InputMaybe<ReportScope>;
  statReportId: Scalars['String'];
};


export type MutationupdateSmsapiDutyScheduleArgs = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  externalAdvertiserId: Scalars['ID'];
  recipients: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationupdateSpendCapArgs = {
  action: SpendCapAction;
  externalAdAccountId: Scalars['ID'];
  reset?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};


export type MutationupdateUserArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  tourFinished?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationupdateWalletFundsArgs = {
  amount: Scalars['Float'];
  bankId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
};


export type MutationuploadProfileImageArgs = {
  file?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['UploadType']>>>;
};

export enum OrderByDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum PaymentType {
  ABANET = 'ABANET',
  ABA_PAY = 'ABA_PAY',
  ACTIVA_PGW = 'ACTIVA_PGW',
  ADVANCE = 'ADVANCE',
  EFUNDS = 'EFUNDS',
  MONETA = 'MONETA',
  PAYPAL = 'PAYPAL',
  PI_PAY = 'PI_PAY',
  SSL_COMMERZ = 'SSL_COMMERZ',
  STRIPE = 'STRIPE',
  TRUE_MONEY = 'TRUE_MONEY'
}

export type PaymentTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<PaymentType>>;
};

export type PermissionConfig = {
  admin?: InputMaybe<Array<Scalars['String']>>;
  default?: InputMaybe<Array<Scalars['String']>>;
  network?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Array<Scalars['String']>>;
};

export type PermittedExternalAdvertiser = {
  externalAdvertiserId: Scalars['ID'];
  permitted?: InputMaybe<Scalars['Boolean']>;
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  customerId?: Maybe<Scalars['ID']>;
  profileImageEncoded?: Maybe<Scalars['String']>;
  profileImageMimeType?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get initial metadata for admin interface */
  adminMetadata?: Maybe<AdminMetadata>;
  adminUsers?: Maybe<AdminUsersCursored>;
  businessEmailRecipients?: Maybe<BusinessEmailRecipientsCursored>;
  businessUsers?: Maybe<Array<BusinessUser>>;
  businesses?: Maybe<BusinessCursored>;
  countries?: Maybe<Array<Country>>;
  creditSettings?: Maybe<CreditSettingCursored>;
  customerNotices: CustomerNoticeCursored;
  customers?: Maybe<CustomersCursored>;
  deposits?: Maybe<DepositsCursored>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  extendedCreditInvoiceGroups?: Maybe<ExtendedCreditInvoiceGroupsCursored>;
  /**  External ad account activity  */
  externalAdAccountActivity: ExternalAdAccountActivityCursored;
  /** Get an external Facebook ad account's agencies. */
  externalAdAccountAgencies?: Maybe<ExternalAdAccountAgenciesCursored>;
  externalAdAccountTransactions?: Maybe<ExternalAdAccountTransactionsCursored>;
  externalAdAccounts?: Maybe<ExternalAdAccountsCursored>;
  externalAdAccountsAggregated?: Maybe<ExternalAdAccountsAggregated>;
  externalAdvertisers?: Maybe<ExternalAdvertisersCursored>;
  fbCurrencies?: Maybe<FbCurrencyCursored>;
  fbUser?: Maybe<FbUser>;
  filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** 	Used to check if user has access to all ad accounts in adAccountIds. */
  hasAdAccountsPermission?: Maybe<Scalars['Boolean']>;
  /**  Get import settings for entities  */
  importSettings?: Maybe<ImportSettingsCursored>;
  /** Get initial meta data for user interface */
  localeMetadata?: Maybe<LocaleMetadata>;
  metrics?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImage?: Maybe<ProfileImage>;
  reportUrl?: Maybe<Scalars['String']>;
  reports?: Maybe<ReportsCursored>;
  selfOnboardingBusinesses?: Maybe<Array<SelfOnboardingBusiness>>;
  smsapiDutySchedule?: Maybe<Array<Maybe<SMSApiDutySchedule>>>;
  smsapiMessage?: Maybe<SMSApiMessage>;
  statistics?: Maybe<StatisticsCursored>;
  transactionsExternal?: Maybe<TransactionsExternalCursored>;
  users?: Maybe<UsersCursored>;
  version?: Maybe<Scalars['String']>;
  walletPaymentInstructions?: Maybe<WalletPaymentInstructions>;
  wallets?: Maybe<WalletsCursored>;
};


export type QueryadminUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AdminUserFilter>;
  filterExclude?: InputMaybe<AdminUserFilter>;
  filters?: InputMaybe<AdminUserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerybusinessEmailRecipientsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<BusinessEmailRecipientsFilter>;
  filterExclude?: InputMaybe<BusinessEmailRecipientsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerybusinessUsersArgs = {
  externalAdvertiserId: Scalars['String'];
  filter?: InputMaybe<BusinessUserFilter>;
};


export type QuerybusinessesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<BusinessFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerycountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerycreditSettingsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CreditSettingFilter>;
  filterExclude?: InputMaybe<CreditSettingFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerycustomerNoticesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CustomerNoticeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomerNoticeOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerycustomersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CustomerFilter>;
  filterExclude?: InputMaybe<CustomerFilter>;
  filters?: InputMaybe<CustomerFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerydepositsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DepositFilter>;
  filterExclude?: InputMaybe<DepositFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryextendedCreditInvoiceGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExtendedCreditInvoiceGroupOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryexternalAdAccountActivityArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExternalAdAccountActivityFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalAdAccountActivityOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryexternalAdAccountAgenciesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ExternalAdAccountAgencyFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalAdAccountAgencyOrderBy>>;
};


export type QueryexternalAdAccountTransactionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExternalAdAccountTransactionFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountTransactionFilter>;
  filters?: InputMaybe<ExternalAdAccountTransactionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryexternalAdAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExternalAdAccountFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
  filters?: InputMaybe<ExternalAdAccountFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryexternalAdAccountsAggregatedArgs = {
  filter?: InputMaybe<ExternalAdAccountFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
  filters?: InputMaybe<ExternalAdAccountFilters>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryexternalAdvertisersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExternalAdvertiserFilter>;
  filterExclude?: InputMaybe<ExternalAdvertiserFilter>;
  filters?: InputMaybe<ExternalAdvertiserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryfbCurrenciesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FbCurrencyFilter>;
  filterExclude?: InputMaybe<FbCurrencyFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryfbUserArgs = {
  filter?: InputMaybe<FbUserFilter>;
};


export type QueryhasAdAccountsPermissionArgs = {
  adAccountIds: Array<Scalars['ID']>;
};


export type QueryimportSettingsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters: ImportSettingFilters;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryprofileImageArgs = {
  customerId: Scalars['ID'];
};


export type QueryreportsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryselfOnboardingBusinessesArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QuerysmsapiDutyScheduleArgs = {
  filter?: InputMaybe<SMSApiDutyScheduleFilter>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerysmsapiMessageArgs = {
  filter?: InputMaybe<SMSApiMessageFilter>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerystatisticsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<StatisticsFilter>;
  filterExclude?: InputMaybe<StatisticsFilter>;
  filters?: InputMaybe<StatisticsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerytransactionsExternalArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TransactionExternalFilter>;
  filterExclude?: InputMaybe<TransactionExternalFilter>;
  filters?: InputMaybe<TransactionExternalFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryusersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilter>;
  filters?: InputMaybe<UserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerywalletPaymentInstructionsArgs = {
  depositId: Scalars['ID'];
};


export type QuerywalletsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<WalletFilter>;
  filterExclude?: InputMaybe<WalletFilter>;
  filters?: InputMaybe<WalletFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueueEmail = {
  __typename?: 'QueueEmail';
  id?: Maybe<Scalars['String']>;
};

export type Report = {
  __typename?: 'Report';
  actionFormat?: Maybe<Scalars['String']>;
  actionOptions?: Maybe<Scalars['String']>;
  actionType?: Maybe<Scalars['String']>;
  activatedAt?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  dataset?: Maybe<Scalars['String']>;
  dateRangeOptions?: Maybe<Scalars['String']>;
  dateType?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  filtersOptions?: Maybe<Scalars['String']>;
  hideZeroRows?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  metrics?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  overviewType?: Maybe<Scalars['String']>;
  reportReady?: Maybe<Scalars['String']>;
  reportUrl?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['ID']>;
  scopeShare?: Maybe<Scalars['String']>;
  scopeType?: Maybe<Scalars['String']>;
  statReportApiId?: Maybe<Scalars['ID']>;
  statReportId?: Maybe<Scalars['ID']>;
  token?: Maybe<Scalars['String']>;
};

export type ReportAction = {
  actionFormat: ReportActionFormat;
  actionOptions?: InputMaybe<Array<InputMaybe<ReportActionOption>>>;
  actionType: ReportActionType;
};

export enum ReportActionFormat {
  csv = 'csv',
  excel = 'excel',
  inline = 'inline',
  json = 'json'
}

export type ReportActionOption = {
  actionOptionType: ReportActionOptionType;
  actionOptionValue?: InputMaybe<Array<Scalars['String']>>;
};

export enum ReportActionOptionType {
  action_emails = 'action_emails',
  dataset = 'dataset',
  from = 'from',
  table = 'table'
}

export enum ReportActionType {
  bigquery = 'bigquery',
  email = 'email',
  show = 'show',
  url = 'url'
}

export type ReportCondition = {
  metric: Scalars['String'];
  operator: Scalars['String'];
  value: Scalars['String'];
};

export type ReportDateOption = {
  dateRange?: InputMaybe<ReportDateRangeType>;
  dateType: ReportDateType;
};

export type ReportDateRange = {
  dateRangeType: ReportDateRangeType;
  dateRangeValue?: InputMaybe<Array<Scalars['String']>>;
};

export enum ReportDateRangeType {
  date_schedule = 'date_schedule',
  days_value = 'days_value'
}

export enum ReportDateType {
  current_month = 'current_month',
  current_week = 'current_week',
  current_year = 'current_year',
  custom = 'custom',
  from = 'from',
  last = 'last',
  previous = 'previous',
  previous_3_months = 'previous_3_months',
  previous_month = 'previous_month',
  previous_week = 'previous_week',
  today = 'today',
  yesterday = 'yesterday'
}

export enum ReportFilterAction {
  exclude = 'exclude',
  include = 'include'
}

export type ReportFilterOption = {
  action?: InputMaybe<ReportFilterAction>;
  filter: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
  value?: InputMaybe<Array<Scalars['String']>>;
};

export enum ReportLanguage {
  en = 'en',
  si = 'si'
}

export enum ReportOverview {
  advertiser = 'advertiser',
  publisher = 'publisher'
}

export enum ReportSchedule {
  every_monday = 'every_monday',
  every_weekday = 'every_weekday',
  first_of_the_month = 'first_of_the_month',
  only_once = 'only_once'
}

export type ReportScope = {
  scopeId: Scalars['String'];
  scopeShare: Scalars['Boolean'];
  scopeType: Scalars['String'];
};

export type ReportsCursored = {
  __typename?: 'ReportsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<Report>>>;
};

export type SMSApiDutySchedule = {
  __typename?: 'SMSApiDutySchedule';
  dateFrom?: Maybe<Scalars['DateOptionalTime']>;
  dateTo?: Maybe<Scalars['DateOptionalTime']>;
  externalAdvertiserId: Scalars['ID'];
  recipientId?: Maybe<Scalars['ID']>;
  smsapiDutyScheduleId?: Maybe<Scalars['ID']>;
};

export type SMSApiDutyScheduleFilter = {
  dateFrom?: InputMaybe<Scalars['DateOptionalTime']>;
  dateTo?: InputMaybe<Scalars['DateOptionalTime']>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  smsapiDutyScheduleId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SMSApiMessage = {
  __typename?: 'SMSApiMessage';
  encoding?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  sender: Scalars['String'];
  smsapiMessageId: Scalars['ID'];
};

export type SMSApiMessageFilter = {
  recipients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sender?: InputMaybe<Scalars['String']>;
  smsapiMessageId?: InputMaybe<Scalars['ID']>;
};

export type SSOUser = {
  accessToken: Scalars['String'];
  accessTokenExpiresAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type SelfOnboardingBusiness = {
  __typename?: 'SelfOnboardingBusiness';
  businessCountryId?: Maybe<Scalars['ID']>;
  businessId: Scalars['ID'];
  externalAdvertiserId?: Maybe<Scalars['ID']>;
};

export type SingleDateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTime'];
};

export type SingleFloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Float'];
};

export type SingleIdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['ID'];
};

export type SingleIntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type SingleStringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export enum SpendCapAction {
  /**  Add additional funds to Facebook ad account  */
  ADD = 'ADD',
  /**  Remove some funds from Facebook ad account  */
  REMOVE = 'REMOVE',
  /**  Remove all funds */
  REMOVE_ALL = 'REMOVE_ALL',
  /**  Set account funds to a specific value  */
  SET = 'SET'
}

export type Statistics = {
  __typename?: 'Statistics';
  actionRate?: Maybe<Scalars['Float']>;
  actions?: Maybe<Scalars['Int']>;
  adId?: Maybe<Scalars['ID']>;
  age?: Maybe<Scalars['String']>;
  appStoreClicks?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  canvasAvgViewPercent?: Maybe<Scalars['Float']>;
  canvasAvgViewTime?: Maybe<Scalars['Float']>;
  clicks?: Maybe<Scalars['String']>;
  conversionRate?: Maybe<Scalars['Float']>;
  conversions?: Maybe<Scalars['Int']>;
  cpa?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpcv?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  cpwc?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  currentMonthSpend?: Maybe<Scalars['Float']>;
  customerFullName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  customerName?: Maybe<Scalars['String']>;
  customerSurname?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dayOfMonth?: Maybe<Scalars['Int']>;
  deeplinkClicks?: Maybe<Scalars['String']>;
  extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  extendedCreditInvoiceGroupName?: Maybe<Scalars['String']>;
  externalAdAccountId?: Maybe<Scalars['ID']>;
  externalAdAccountName?: Maybe<Scalars['String']>;
  externalAdId?: Maybe<Scalars['ID']>;
  externalAdvertiserId?: Maybe<Scalars['ID']>;
  externalCampaignId?: Maybe<Scalars['ID']>;
  externalGroupId?: Maybe<Scalars['ID']>;
  gender?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  impressions?: Maybe<Scalars['String']>;
  inlineLinkClicks?: Maybe<Scalars['String']>;
  inlinePostEngagement?: Maybe<Scalars['String']>;
  lastMonthSpend?: Maybe<Scalars['Float']>;
  lastYearSpend?: Maybe<Scalars['Float']>;
  max30DaySpend?: Maybe<Scalars['Float']>;
  mobileAppPurchaseRoas?: Maybe<Scalars['Float']>;
  monthName?: Maybe<Scalars['String']>;
  monthNumber?: Maybe<Scalars['Int']>;
  newsfeedAvgPosition?: Maybe<Scalars['Float']>;
  newsfeedClicks?: Maybe<Scalars['String']>;
  newsfeedImpressions?: Maybe<Scalars['String']>;
  outboundClicks?: Maybe<Scalars['String']>;
  purchaseRoas?: Maybe<Scalars['Float']>;
  quarter?: Maybe<Scalars['String']>;
  socialSpend?: Maybe<Scalars['Float']>;
  spend?: Maybe<Scalars['Float']>;
  thisYearSpend?: Maybe<Scalars['Float']>;
  uniqueClicks?: Maybe<Scalars['String']>;
  uniqueImpressions?: Maybe<Scalars['String']>;
  uniqueInlineLinkClicks?: Maybe<Scalars['String']>;
  uniqueOutboundClicks?: Maybe<Scalars['String']>;
  video10SecWatched?: Maybe<Scalars['String']>;
  video30SecWatched?: Maybe<Scalars['String']>;
  videoAverageTimeWatched?: Maybe<Scalars['String']>;
  videoComplete?: Maybe<Scalars['String']>;
  videoP25Watched?: Maybe<Scalars['String']>;
  videoP50Watched?: Maybe<Scalars['String']>;
  videoP75Watched?: Maybe<Scalars['String']>;
  videoP95Watched?: Maybe<Scalars['String']>;
  videoP100Watched?: Maybe<Scalars['String']>;
  websiteClickRate?: Maybe<Scalars['Float']>;
  websiteClicks?: Maybe<Scalars['String']>;
  websitePurchaseRoas?: Maybe<Scalars['Float']>;
  weekNumber?: Maybe<Scalars['Int']>;
  weekdayName?: Maybe<Scalars['String']>;
  weekdayNumber?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
  yearMonth?: Maybe<Scalars['String']>;
};

export type StatisticsCursored = {
  __typename?: 'StatisticsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Statistics>>;
};

export type StatisticsFilter = {
  adId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  age?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  campaignId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  currency?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerFullName?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerName?: InputMaybe<Scalars['String']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  dayOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  extendedCreditInvoiceGroupName?: InputMaybe<Scalars['String']>;
  externalAdAccountId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdAccountName?: InputMaybe<Scalars['String']>;
  externalAdAccountStatus?: InputMaybe<Array<ExternalAdAccountStatus>>;
  externalAdAccountType?: InputMaybe<Array<Scalars['String']>>;
  externalAdId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdvertiserId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalCampaignId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  gender?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  monthName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  monthNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  quarter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weekNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weekdayName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weekdayNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  year?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yearMonth?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StatisticsFilters = {
  adId?: InputMaybe<Array<IdFilter>>;
  age?: InputMaybe<Array<StringFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
  currency?: InputMaybe<Array<StringFilter>>;
  customerFullName?: InputMaybe<Array<StringFilter>>;
  customerId?: InputMaybe<Array<IdFilter>>;
  customerName?: InputMaybe<Array<StringFilter>>;
  customerSurname?: InputMaybe<Array<StringFilter>>;
  date?: InputMaybe<Array<StringFilter>>;
  dayOfMonth?: InputMaybe<Array<IntFilter>>;
  extendedCreditInvoiceGroupId?: InputMaybe<Array<IdFilter>>;
  extendedCreditInvoiceGroupName?: InputMaybe<Array<StringFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountName?: InputMaybe<Array<StringFilter>>;
  externalAdAccountStatus?: InputMaybe<Array<ExternalAdAccountStatusFilter>>;
  externalAdAccountType?: InputMaybe<Array<StringFilter>>;
  externalAdId?: InputMaybe<Array<IdFilter>>;
  externalAdvertiserId?: InputMaybe<Array<IdFilter>>;
  externalCampaignId?: InputMaybe<Array<IdFilter>>;
  externalGroupId?: InputMaybe<Array<IdFilter>>;
  gender?: InputMaybe<Array<StringFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
  monthName?: InputMaybe<Array<StringFilter>>;
  monthNumber?: InputMaybe<Array<IntFilter>>;
  quarter?: InputMaybe<Array<StringFilter>>;
  weekNumber?: InputMaybe<Array<IntFilter>>;
  weekdayName?: InputMaybe<Array<StringFilter>>;
  weekdayNumber?: InputMaybe<Array<IntFilter>>;
  year?: InputMaybe<Array<IntFilter>>;
  yearMonth?: InputMaybe<Array<StringFilter>>;
};

export type StringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

/** Transaction external */
export type TransactionExternal = {
  __typename?: 'TransactionExternal';
  bankId: Scalars['ID'];
  businessCurrency?: Maybe<Scalars['String']>;
  customerCompanyName?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  customerName?: Maybe<Scalars['String']>;
  customerSurname?: Maybe<Scalars['String']>;
  /** externalAdAccountTransactions: [ExternalAdAccountTransaction] */
  externalAdAccountTransactions?: Maybe<Array<ExternalAdAccountTransaction>>;
  modifierFullName?: Maybe<Scalars['String']>;
  transactionExternalAmount?: Maybe<Scalars['Float']>;
  transactionExternalDescription?: Maybe<Scalars['String']>;
  transactionExternalEntryDate?: Maybe<Scalars['String']>;
  transactionExternalId?: Maybe<Scalars['ID']>;
  transactionExternalStatus?: Maybe<TransactionExternalStatus>;
  transactionExternalTransactionType?: Maybe<Scalars['String']>;
};


/** Transaction external */
export type TransactionExternalexternalAdAccountTransactionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExternalAdAccountTransactionFilter>;
  filterExclude?: InputMaybe<ExternalAdAccountTransactionFilter>;
  filters?: InputMaybe<ExternalAdAccountTransactionFilters>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};

export type TransactionExternalFilter = {
  bankId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customerId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalAdAccountId?: InputMaybe<Array<Scalars['String']>>;
  externalAdAccountTransactionId?: InputMaybe<Array<Scalars['String']>>;
  externalAdAccountTransactionStatus?: InputMaybe<Array<Scalars['String']>>;
  modifierFullName?: InputMaybe<Scalars['String']>;
  transactionExternalEntryDateFrom?: InputMaybe<Scalars['DateOptionalTime']>;
  transactionExternalEntryDateTo?: InputMaybe<Scalars['DateOptionalTime']>;
  transactionExternalId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionExternalStatus?: InputMaybe<Array<InputMaybe<TransactionExternalStatus>>>;
  transactionExternalTransactionType?: InputMaybe<Array<InputMaybe<TransactionExternalType>>>;
};

export type TransactionExternalFilters = {
  bankId?: InputMaybe<Array<IdFilter>>;
  customerId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountId?: InputMaybe<Array<IdFilter>>;
  externalAdAccountTransactionId?: InputMaybe<Array<IdFilter>>;
  modifierFullName?: InputMaybe<Array<StringFilter>>;
  transactionExternalEntryDate?: InputMaybe<Array<DateRangeFilter>>;
  transactionExternalId?: InputMaybe<Array<IdFilter>>;
  transactionExternalStatus?: InputMaybe<Array<TransactionExternalStatusFilter>>;
  transactionExternalTransactionType?: InputMaybe<Array<TransactionExternalTypeFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export enum TransactionExternalStatus {
  FAILED = 'FAILED',
  PARTIALLY_PROCESSED = 'PARTIALLY_PROCESSED',
  PROCESSED = 'PROCESSED'
}

export type TransactionExternalStatusFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<TransactionExternalStatus>>;
};

export enum TransactionExternalType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  TRANSFER = 'TRANSFER'
}

export type TransactionExternalTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<TransactionExternalType>>;
};

export enum TransactionStatus {
  CANCELLED = 'CANCELLED',
  FB_PENDING = 'FB_PENDING',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  REJECTED = 'REJECTED',
  ZOHO_PENDING = 'ZOHO_PENDING'
}

export type TransactionStatusFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<TransactionStatus>>;
};

export type TransactionsExternalCursored = {
  __typename?: 'TransactionsExternalCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TransactionExternal>>;
};

export type TransferExternalAdAccountInput = {
  /** Currency amount which will be applied to the ad account. */
  amount: Scalars['Float'];
  /** ID of external Facebook ad account to which the operation should be applied. */
  externalAdAccountId: Scalars['ID'];
};

export type UploadProfileImage = {
  __typename?: 'UploadProfileImage';
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimeType?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  credentials?: Maybe<Array<Maybe<Credential>>>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  userCompanyName?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userIsActivated?: Maybe<Scalars['Int']>;
  userIsDeleted?: Maybe<Scalars['Int']>;
  userIsValidated?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  userSurname?: Maybe<Scalars['String']>;
  userTourFinished?: Maybe<Scalars['Int']>;
};

export type UserFilter = {
  userCompanyName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userIsActivated?: InputMaybe<Scalars['Boolean']>;
  userIsDeleted?: InputMaybe<Scalars['Boolean']>;
  userIsValidated?: InputMaybe<Scalars['Boolean']>;
  userName?: InputMaybe<Scalars['String']>;
  userSurname?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UserFilters = {
  userCompanyName?: InputMaybe<Array<StringFilter>>;
  userEmail?: InputMaybe<Array<StringFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
  userIsActivated?: InputMaybe<Array<BooleanFilter>>;
  userIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  userIsValidated?: InputMaybe<Array<BooleanFilter>>;
  userName?: InputMaybe<Array<StringFilter>>;
  userSurname?: InputMaybe<Array<StringFilter>>;
};

export type UsersCursored = {
  __typename?: 'UsersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<User>>>;
};

export type Wallet = {
  __typename?: 'Wallet';
  bankCurrency?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['ID']>;
  customerFullName?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  walletBalance?: Maybe<Scalars['Float']>;
  walletId: Scalars['ID'];
};

export type WalletFilter = {
  customerId?: InputMaybe<Scalars['ID']>;
  walletId?: InputMaybe<Scalars['ID']>;
};

export type WalletFilters = {
  customerId?: InputMaybe<Array<IdFilter>>;
  walletId?: InputMaybe<Array<IdFilter>>;
};

export type WalletPaymentInstructions = {
  __typename?: 'WalletPaymentInstructions';
  content?: Maybe<Scalars['String']>;
};

export type WalletsCursored = {
  __typename?: 'WalletsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Wallet>>;
};

export type Withdraw = {
  __typename?: 'Withdraw';
  bankId: Scalars['ID'];
  customerAddress?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCompanyName?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  customerName?: Maybe<Scalars['String']>;
  customerSurname?: Maybe<Scalars['String']>;
  customerTaxNumber?: Maybe<Scalars['String']>;
  externalAdAccountCurrency?: Maybe<Scalars['String']>;
  externalAdAccountName?: Maybe<Scalars['String']>;
  withdrawAmount: Scalars['Float'];
  withdrawDescription?: Maybe<Scalars['String']>;
  withdrawEntryDate?: Maybe<Scalars['String']>;
  withdrawId: Scalars['ID'];
  withdrawIncomeTaxBasePercentage: Scalars['Float'];
  withdrawIncomeTaxPercentage: Scalars['Float'];
  withdrawIsAutoGenerated: Scalars['Boolean'];
  withdrawIsSent: Scalars['Boolean'];
  withdrawNumber: Scalars['String'];
  withdrawReferenceBase: Scalars['String'];
  withdrawReferenceFinal?: Maybe<Scalars['String']>;
  withdrawReferenceNumber: Scalars['Int'];
  withdrawReferenceYear: Scalars['String'];
  withdrawStatus: Scalars['String'];
  withdrawStatusTime: Scalars['String'];
  withdrawTaxPercentage: Scalars['Float'];
};

export type kvsKey = {
  __typename?: 'kvsKey';
  key?: Maybe<Scalars['String']>;
};

export type reportScope = {
  scopeId: Scalars['String'];
  scopeShare: Scalars['Boolean'];
  scopeType: Scalars['String'];
};

export type updateExternalAdAccountMutationVariables = Exact<{
  externalAdAccountId: Scalars['ID'];
  type: AdAccountType;
  minSpendCap?: InputMaybe<Scalars['Float']>;
  maxSpendCap?: InputMaybe<Scalars['Float']>;
  spendFactor?: InputMaybe<Scalars['Float']>;
}>;


export type updateExternalAdAccountMutation = { __typename?: 'Mutation', updateExternalAdAccount?: { __typename?: 'ExternalAdAccount', externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountId?: string | null, externalAdAccountName?: string | null, spendCap?: number | null, spendFactor?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, amountSpent?: number | null, type?: string | null } | null };

export type getAdAccountsForCreditLimitModalQueryVariables = Exact<{
  filters?: InputMaybe<ExternalAdAccountFilters>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type getAdAccountsForCreditLimitModalQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountName?: string | null, extendedCreditInvoiceGroupId?: string | null, externalAdAccountDefaultCreditLimit?: number | null, extendedCreditInvoiceGroupCreditLimit?: number | null, extendedCreditInvoiceGroupName?: string | null, currentMonthSpend?: number | null, id?: string | null, currency?: FacebookCurrency | null } | null> | null } | null };

export type allImportSettingsQueryVariables = Exact<{
  groupFilters: ImportSettingFilters;
  businessFilters: ImportSettingFilters;
}>;


export type allImportSettingsQuery = { __typename?: 'Query', groupSettings?: { __typename?: 'ImportSettingsCursored', items?: Array<{ __typename?: 'ImportSetting', groupId: string, settings?: Array<{ __typename?: 'ImportSettingNameValue', settingName: ImportSettingName, settingValue?: string | null }> | null }> | null } | null, businessSettings?: { __typename?: 'ImportSettingsCursored', items?: Array<{ __typename?: 'ImportSetting', businessId: string, settings?: Array<{ __typename?: 'ImportSettingNameValue', settingName: ImportSettingName, settingValue?: string | null }> | null }> | null } | null, globalSettings?: { __typename?: 'ImportSettingsCursored', items?: Array<{ __typename?: 'ImportSetting', businessId: string, settings?: Array<{ __typename?: 'ImportSettingNameValue', settingName: ImportSettingName, settingValue?: string | null }> | null }> | null } | null };

export type getInvoiceGroupOptionsForAsyncDropdownQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getInvoiceGroupOptionsForAsyncDropdownQuery = { __typename?: 'Query', entities?: { __typename?: 'ExtendedCreditInvoiceGroupsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExtendedCreditInvoiceGroup', value?: string | null, label?: string | null, id?: string | null, businessId?: string | null, currency?: string | null } | null> | null } | null };

export type getInvoiceGroupOptionsForFilterQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type getInvoiceGroupOptionsForFilterQuery = { __typename?: 'Query', entities?: { __typename?: 'ExtendedCreditInvoiceGroupsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExtendedCreditInvoiceGroup', value?: string | null, label?: string | null, id?: string | null } | null> | null } | null };

export type getAdAccountsOptionsForFilterQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<ExternalAdAccountFilters>;
  cursor?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getAdAccountsOptionsForFilterQuery = { __typename?: 'Query', entities?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', value?: string | null, label?: string | null, id?: string | null } | null> | null } | null };

export type getFbAdAccStatisticsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getFbAdAccStatisticsQuery = { __typename?: 'Query', externalAdAccountsAggregated?: { __typename?: 'ExternalAdAccountsAggregated', externalAdAccountLifetimeSpend?: number | null, lastMonthSpend?: number | null, currentMonthSpend?: number | null, externalAdAccountAmountSpent?: number | null, externalAdAccountSpendCap?: number | null, externalAdAccountFundsLeft?: number | null, externalAdAccountCurrency?: string | null, externalAdAccountFundsLeftAreUnlimited?: boolean | null } | null };

export type getCurrencyOptionsQueryVariables = Exact<{
  filters?: InputMaybe<ExternalAdAccountFilters>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getCurrencyOptionsQuery = { __typename?: 'Query', currencies?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', id?: FacebookCurrency | null, value?: FacebookCurrency | null, label?: FacebookCurrency | null } | null> | null } | null };

export type getSpendCapChangelogQueryVariables = Exact<{
  externalAdAccountId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type getSpendCapChangelogQuery = { __typename?: 'Query', externalAdAccountActivity: { __typename?: 'ExternalAdAccountActivityCursored', items?: Array<{ __typename?: 'ExternalAdAccountActivity', actorName?: string | null, actorId: string, applicationName?: string | null, eventTime: string, eventType: string, extraData: string }> | null } };

export type updateDepositMutationVariables = Exact<{
  depositId: Scalars['ID'];
  depositAmount?: InputMaybe<Scalars['Float']>;
  depositStatus?: InputMaybe<TransactionStatus>;
  depositReferenceFinal?: InputMaybe<Scalars['String']>;
  depositDescription?: InputMaybe<Scalars['String']>;
}>;


export type updateDepositMutation = { __typename?: 'Mutation', updateDeposit?: { __typename?: 'Deposit', depositId?: string | null, depositAmount?: number | null, depositStatus?: TransactionStatus | null, depositStatusTime?: any | null, depositReferenceYear?: number | null, depositReferenceFinal?: string | null, depositPaymentType?: PaymentType | null, depositTaxPercentage?: number | null, depositEntryDate?: any | null, depositDescription?: string | null, depositInvoiceNumber?: string | null, depositPaymentDueTime?: any | null, customerCompanyName?: string | null, depositInvoiceUrl?: string | null, bankCurrency?: string | null, depositModifierFullName?: string | null } | null };

export type getAdAccountOptionsForReportFilterQueryVariables = Exact<{
  filters?: InputMaybe<ExternalAdAccountFilters>;
  query?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type getAdAccountOptionsForReportFilterQuery = { __typename?: 'Query', entities?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', id?: string | null, value?: string | null, label?: string | null } | null> | null } | null };

export type updateAdminInfoMutationVariables = Exact<{
  userId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['Email']>;
  fbEmail?: InputMaybe<Scalars['Email']>;
  login?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type updateAdminInfoMutation = { __typename?: 'Mutation', updateAdminUser?: { __typename?: 'AdminUser', id?: string | null, name?: string | null, surname?: string | null, email?: string | null, fbEmail?: string | null, login?: string | null, hasAgreedToTerms?: boolean | null, isDeleted?: boolean | null, phone?: string | null } | null };

export type updateAdminPermissionsMutationVariables = Exact<{
  userId: Scalars['ID'];
  permittedAdvertisers?: InputMaybe<Array<InputMaybe<PermittedExternalAdvertiser>> | InputMaybe<PermittedExternalAdvertiser>>;
}>;


export type updateAdminPermissionsMutation = { __typename?: 'Mutation', updateAdminUser?: { __typename?: 'AdminUser', id?: string | null, permittedExternalAdvertisers?: Array<{ __typename?: 'ExternalAdvertiser', externalAdvertiserId?: string | null }> | null } | null };

export type updateAdminCredentialsMutationVariables = Exact<{
  userId: Scalars['ID'];
  credentials?: InputMaybe<Array<InputMaybe<CredentialInput>> | InputMaybe<CredentialInput>>;
}>;


export type updateAdminCredentialsMutation = { __typename?: 'Mutation', updateAdminUser?: { __typename?: 'AdminUser', id?: string | null, credentials?: Array<{ __typename?: 'Credential', name?: string | null, read?: boolean | null, write?: boolean | null, delete?: boolean | null } | null> | null } | null };

export type createAdminMutationVariables = Exact<{
  name: Scalars['String'];
  surname: Scalars['String'];
  email: Scalars['Email'];
  fbEmail?: InputMaybe<Scalars['Email']>;
  login: Scalars['String'];
  password: Scalars['String'];
  credentials: Array<InputMaybe<CredentialInput>> | InputMaybe<CredentialInput>;
  permittedAdvertisers?: InputMaybe<Array<InputMaybe<PermittedExternalAdvertiser>> | InputMaybe<PermittedExternalAdvertiser>>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type createAdminMutation = { __typename?: 'Mutation', createAdminUser?: { __typename?: 'AdminUser', id?: string | null, name?: string | null, surname?: string | null, email?: string | null, fbEmail?: string | null, login?: string | null, hasAgreedToTerms?: boolean | null, isDeleted?: boolean | null, phone?: string | null, credentials?: Array<{ __typename?: 'Credential', name?: string | null, read?: boolean | null, write?: boolean | null, delete?: boolean | null } | null> | null, permittedExternalAdvertisers?: Array<{ __typename?: 'ExternalAdvertiser', externalAdvertiserId?: string | null }> | null } | null };

export type getBMOptionsOnClientsQueryVariables = Exact<{
  filters?: InputMaybe<ExternalAdvertiserFilters>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getBMOptionsOnClientsQuery = { __typename?: 'Query', entities?: { __typename?: 'ExternalAdvertisersCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdvertiser', id?: string | null, business?: { __typename?: 'Business', businessId: string, businessName?: string | null } | null }> | null } | null };

export type getCountriesQueryVariables = Exact<{
  filter?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type getCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', value?: string | null, label?: string | null }> | null };

export type getAllExternalAdAccountsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
}>;


export type getAllExternalAdAccountsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountCurrency?: FacebookCurrency | null } | null> | null } | null };

export type ExternalAdAccountsBalanceFieldsFragment = { __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null, externalAdAccountSpendCap?: number | null, id?: string | null };

export type getFbAdAccOptionsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getFbAdAccOptionsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', customerId?: string | null, id?: string | null, value?: string | null, label?: string | null, currency?: FacebookCurrency | null } | null> | null } | null };

export type getFbAdAccFilterOptionsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getFbAdAccFilterOptionsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', value?: string | null, label?: string | null } | null> | null } | null };

export type getAdAccountsBalanceAdminQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
}>;


export type getAdAccountsBalanceAdminQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null, externalAdAccountSpendCap?: number | null, id?: string | null } | null> | null } | null };

export type getInvoiceGroupsBalanceQueryVariables = Exact<{
  filters?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
}>;


export type getInvoiceGroupsBalanceQuery = { __typename?: 'Query', extendedCreditInvoiceGroups?: { __typename?: 'ExtendedCreditInvoiceGroupsCursored', items?: Array<{ __typename?: 'ExtendedCreditInvoiceGroup', extendedCreditInvoiceGroupFundsLeft?: string | null, extendedCreditInvoiceGroupSpendCap?: string | null, id?: string | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null, externalAdAccountSpendCap?: number | null, id?: string | null } | null> | null, availableFunds?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null } | null> | null } | null> | null } | null };

export type getFbAdAccountsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
}>;


export type getFbAdAccountsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, id?: string | null, value?: string | null, label?: string | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, autoRebalancedSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null } | null> | null } | null };

export type updateSpendCapMutationVariables = Exact<{
  externalAdAccountId: Scalars['ID'];
  action: SpendCapAction;
  value?: InputMaybe<Scalars['Float']>;
}>;


export type updateSpendCapMutation = { __typename?: 'Mutation', updateSpendCap: { __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, id?: string | null, spendCap?: number | null, fundsLeft?: number | null, amountSpent?: number | null, currency?: FacebookCurrency | null } };

export type refreshExternalAdAccountsMutationVariables = Exact<{
  externalAdAccountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type refreshExternalAdAccountsMutation = { __typename?: 'Mutation', refreshExternalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, spendCap?: number | null, amountSpent?: number | null }> | null };

export type doneMutationVariables = Exact<{
  customerName?: InputMaybe<Scalars['String']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerEmail: Scalars['String'];
  customerProfileImage?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  customerCountryId: Scalars['String'];
  bankType?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  customerContractSigned?: InputMaybe<Scalars['Boolean']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  externalAdAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  businessId?: InputMaybe<Scalars['ID']>;
  fbUserEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type doneMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', customerId?: string | null, customerFullName?: string | null, customerStatus?: CustomerStatus | null, customerIsDeleted?: number | null, customerIsActivated?: number | null, customerIsFullyRegistered?: number | null, customerHasEContract?: number | null, customerHasValidEContract?: number | null, businessCurrencyTag?: string | null, id?: string | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', id?: string | null, adAccountName?: string | null, spendCap?: number | null, amountSpent?: number | null }> | null } };

export type updateCustomerProfileMutationVariables = Exact<{
  customerId: Scalars['ID'];
  customerName?: InputMaybe<Scalars['String']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerProfileImage?: InputMaybe<Scalars['String']>;
  bankType?: InputMaybe<Scalars['String']>;
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerStatus?: InputMaybe<CustomerStatus>;
}>;


export type updateCustomerProfileMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', customerFullName?: string | null, customerName?: string | null, customerSurname?: string | null, customerPhone?: string | null, customerCompanyName?: string | null, customerSalesforceId?: string | null, customerEmail?: string | null, customerStatus?: CustomerStatus | null, bankType?: string | null, id?: string | null, customerProfileImage?: { __typename?: 'ProfileImage', profileImageEncoded?: string | null, profileImageMimeType?: string | null, file?: string | null } | null } };

export type updateCustomerLocalMutationVariables = Exact<{
  customerId: Scalars['ID'];
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
}>;


export type updateCustomerLocalMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', customerLocalName?: string | null, customerLocalSurname?: string | null, customerLocalAddress?: string | null, customerLocalZip?: string | null, customerLocalCity?: string | null, customerLocalCountry?: string | null, customerLocalCompanyName?: string | null, customerLocalVatNumber?: string | null, bankLocalName?: string | null, bankLocalAccountNumber?: string | null, id?: string | null } };

export type updateCustomerContactMutationVariables = Exact<{
  customerId: Scalars['ID'];
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  customerCountryId?: InputMaybe<Scalars['String']>;
}>;


export type updateCustomerContactMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', customerAddress?: string | null, customerCity?: string | null, customerZip?: string | null, customerCountryId?: string | null, customerCountryName?: string | null, id?: string | null } };

export type updateCustomerAccountMutationVariables = Exact<{
  customerId: Scalars['ID'];
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
}>;


export type updateCustomerAccountMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', bankAccountNumber?: string | null, customerVatNumber?: string | null, customerRegNumber?: string | null, customerIsVatCommitted?: number | null, bankAccountType?: string | null, bankName?: string | null, id?: string | null } };

export type updateCustomerExternalMutationVariables = Exact<{
  customerId: Scalars['ID'];
  externalAdAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  businessId?: InputMaybe<Scalars['ID']>;
}>;


export type updateCustomerExternalMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', businessName?: string | null, id?: string | null, businessManagerId?: string | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', id?: string | null, adAccountName?: string | null, spendCap?: number | null, amountSpent?: number | null }> | null } };

export type updateCustomerAccessMutationVariables = Exact<{
  customerId: Scalars['ID'];
  fbUserEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type updateCustomerAccessMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id?: string | null, users?: Array<{ __typename?: 'User', userEmail?: string | null, id?: string | null }> | null } };

export type segmentFallbackMutationVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type segmentFallbackMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', customerId?: string | null } };

export type CustomerFundsLeftFieldsFragment = { __typename?: 'Customer', externalAdAccountFundsLeftActive?: number | null, externalAdAccountFundsLeftClosed?: number | null, externalAdAccountFundsLeftDisabled?: number | null, externalAdAccountFundsLeftTotal?: number | null, customerAvailableFunds?: number | null };

export type getCustomerDataQueryVariables = Exact<{
  customerId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type getCustomerDataQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersCursored', items?: Array<{ __typename?: 'Customer', customerFullName?: string | null, customerName?: string | null, customerSurname?: string | null, customerCompanyName?: string | null, customerSalesforceId?: string | null, customerEmail?: string | null, customerProfileImageId?: string | null, customerPhone?: string | null, customerAddress?: string | null, customerCity?: string | null, customerZip?: string | null, customerCountryId?: string | null, customerCountryName?: string | null, customerIsDeleted?: number | null, customerIsActivated?: number | null, customerIsFullyRegistered?: number | null, customerHasEContract?: number | null, customerHasValidEContract?: number | null, customerStatus?: CustomerStatus | null, bankAccountNumber?: string | null, customerVatNumber?: string | null, customerRegNumber?: string | null, customerIsVatCommitted?: number | null, bankAccountType?: string | null, bankType?: string | null, bankCurrency?: string | null, businessId?: string | null, bankName?: string | null, businessName?: string | null, customerLocalName?: string | null, customerLocalSurname?: string | null, customerLocalAddress?: string | null, customerLocalZip?: string | null, customerLocalCity?: string | null, customerLocalCountry?: string | null, customerLocalCompanyName?: string | null, customerLocalVatNumber?: string | null, customerContractSigned?: number | null, bankLocalName?: string | null, bankLocalAccountNumber?: string | null, id?: string | null, businessManagerId?: string | null, customerProfileImage?: { __typename?: 'ProfileImage', profileImageEncoded?: string | null, profileImageMimeType?: string | null, file?: string | null } | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', id?: string | null, value?: string | null, label?: string | null, currency?: FacebookCurrency | null }> | null, users?: Array<{ __typename?: 'User', userEmail?: string | null, id?: string | null }> | null }> | null } | null };

export type getCustomersFundsLeftQueryVariables = Exact<{
  customerId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type getCustomersFundsLeftQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersCursored', items?: Array<{ __typename?: 'Customer', customerId?: string | null, customerHasUnlimitedSpendCap?: boolean | null, externalAdAccountFundsLeftActive?: number | null, externalAdAccountFundsLeftClosed?: number | null, externalAdAccountFundsLeftDisabled?: number | null, externalAdAccountFundsLeftTotal?: number | null, customerAvailableFunds?: number | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountName?: string | null, externalAdvertiserId?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, id?: string | null, adAccountName?: string | null, spendCap?: number | null, amountSpent?: number | null, currency?: FacebookCurrency | null }> | null }> | null } | null };

export type getCustomersForGridQueryVariables = Exact<{
  filters?: InputMaybe<CustomerFilters>;
  cursor?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type getCustomersForGridQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersCursored', cursor?: string | null, items?: Array<{ __typename?: 'Customer', customerId?: string | null, customerFullName?: string | null, customerIsDeleted?: number | null, customerIsActivated?: number | null, customerIsFullyRegistered?: number | null, customerHasEContract?: number | null, customerHasValidEContract?: number | null, walletBalance?: number | null, bankCurrency?: string | null, customerStatus?: CustomerStatus | null, customerHasUnlimitedSpendCap?: boolean | null, businessCurrencyTag?: string | null, externalAdAccountFundsLeftActive?: number | null, externalAdAccountFundsLeftClosed?: number | null, externalAdAccountFundsLeftDisabled?: number | null, externalAdAccountFundsLeftTotal?: number | null, customerAvailableFunds?: number | null, id?: string | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountName?: string | null, externalAdvertiserId?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, id?: string | null, adAccountName?: string | null, spendCap?: number | null, amountSpent?: number | null, currency?: FacebookCurrency | null }> | null }> | null } | null };

export type depositsCursoredQueryVariables = Exact<{
  filter?: InputMaybe<DepositFilter>;
  filterExclude?: InputMaybe<DepositFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type depositsCursoredQuery = { __typename?: 'Query', deposits?: { __typename?: 'DepositsCursored', cursor?: string | null, items?: Array<{ __typename?: 'Deposit', depositDiscount?: number | null, depositId?: string | null, depositAmount?: number | null, depositStatus?: TransactionStatus | null, depositStatusTime?: any | null, depositReferenceYear?: number | null, depositReferenceFinal?: string | null, depositPaymentType?: PaymentType | null, depositTaxPercentage?: number | null, depositEntryDate?: any | null, depositDescription?: string | null, depositInvoiceNumber?: string | null, depositPaymentDueTime?: any | null, customerCompanyName?: string | null, customerName?: string | null, customerSurname?: string | null, depositInvoiceUrl?: string | null, bankCurrency?: string | null, depositModifierFullName?: string | null } | null> | null } | null };

export type getAdAccountsForMoveFundsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
}>;


export type getAdAccountsForMoveFundsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, currencyTag?: FacebookCurrency | null, fundsLeft?: number | null } | null> | null } | null };

export type getAdAccountsBalanceQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
}>;


export type getAdAccountsBalanceQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null, id?: string | null } | null> | null } | null };

export type getStatisticsForChartQueryVariables = Exact<{
  filter: StatisticsFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type getStatisticsForChartQuery = { __typename?: 'Query', statistics?: { __typename?: 'StatisticsCursored', items?: Array<{ __typename?: 'Statistics', currency?: string | null, date?: string | null, impressions?: string | null, clicks?: string | null, inlineLinkClicks?: string | null, outboundClicks?: string | null, spend?: number | null, socialSpend?: number | null, purchaseRoas?: number | null, mobileAppPurchaseRoas?: number | null, inlinePostEngagement?: string | null, conversions?: number | null, actions?: number | null, canvasAvgViewTime?: number | null, canvasAvgViewPercent?: number | null, videoAverageTimeWatched?: string | null, videoComplete?: string | null, videoP25Watched?: string | null, videoP50Watched?: string | null, videoP75Watched?: string | null, videoP95Watched?: string | null, videoP100Watched?: string | null, video10SecWatched?: string | null, video30SecWatched?: string | null, ctr?: number | null, websiteClickRate?: number | null, conversionRate?: number | null, actionRate?: number | null, cpm?: number | null, cpc?: number | null, cpwc?: number | null, cpcv?: number | null, cpa?: number | null, amount?: number | null }> | null } | null };

export type getStatisticsForStatBarQueryVariables = Exact<{
  statsFilter: StatisticsFilter;
}>;


export type getStatisticsForStatBarQuery = { __typename?: 'Query', statistics?: { __typename?: 'StatisticsCursored', items?: Array<{ __typename?: 'Statistics', impressions?: string | null, spend?: number | null, conversions?: number | null, currency?: string | null }> | null } | null };

export type getClientStatisticsForGridQueryVariables = Exact<{
  filter?: InputMaybe<StatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getClientStatisticsForGridQuery = { __typename?: 'Query', statistics?: { __typename?: 'StatisticsCursored', cursor?: string | null, items?: Array<{ __typename?: 'Statistics', externalAdAccountId?: string | null, externalAdAccountName?: string | null, impressions?: string | null, clicks?: string | null, currency?: string | null, inlineLinkClicks?: string | null, outboundClicks?: string | null, conversions?: number | null, inlinePostEngagement?: string | null, cpa?: number | null, cpcv?: number | null, cpm?: number | null, cpwc?: number | null, mobileAppPurchaseRoas?: number | null, purchaseRoas?: number | null, actionRate?: number | null, ctr?: number | null, amount?: number | null }> | null } | null };

export type getAdAccountsForGridQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  chartFilter?: InputMaybe<StatisticsFilters>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getAdAccountsForGridQuery = { __typename?: 'Query', gridItems?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountCreditLimitType?: string | null, id?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, spendCapRatio?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, autoRebalancedSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, currentMonthSpend?: number | null, lastMonthSpend?: number | null, fundsLeft?: number | null, chartStats?: Array<{ __typename?: 'Statistics', spend?: number | null, date?: string | null } | null> | null } | null> | null } | null };

export type getPaymentInstructionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getPaymentInstructionsQuery = { __typename?: 'Query', walletPaymentInstructions?: { __typename?: 'WalletPaymentInstructions', content?: string | null } | null };

export type GetTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionExternalFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', transactionsExternal?: { __typename: 'TransactionsExternalCursored', cursor?: string | null, items?: Array<{ __typename: 'TransactionExternal', transactionExternalId?: string | null, transactionExternalTransactionType?: string | null, transactionExternalAmount?: number | null, customerName?: string | null, customerSurname?: string | null, transactionExternalEntryDate?: string | null, businessCurrency?: string | null, customerCompanyName?: string | null, transactionExternalStatus?: TransactionExternalStatus | null, modifierFullName?: string | null, id?: string | null, externalAdAccountTransactions?: Array<{ __typename?: 'ExternalAdAccountTransaction', externalAdAccountId: string, externalAdAccountName?: string | null, externalAdAccountTransactionId: string, externalAdAccountTransactionAmount: number, externalAdAccountCurrency?: string | null, externalAdAccountTransactionStatus: ExternalAdAccountTransactionStatus, id: string }> | null }> | null } | null };

export type createWalletDepositMutationVariables = Exact<{
  bankId: Scalars['ID'];
  amount: Scalars['Float'];
}>;


export type createWalletDepositMutation = { __typename?: 'Mutation', createDeposit?: { __typename?: 'Deposit', depositInvoiceNumber?: string | null, id?: string | null } | null };

export type ExternalAdAccountOptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filterExclude?: InputMaybe<ExternalAdAccountFilter>;
  filter?: InputMaybe<ExternalAdAccountFilter>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ExternalAdAccountOptionsQuery = { __typename?: 'Query', entities?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', id?: string | null, value?: string | null, label?: string | null } | null> | null } | null };

export type getClientOptionsQueryVariables = Exact<{
  filters: CustomerFilters;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getClientOptionsQuery = { __typename?: 'Query', entities?: { __typename?: 'CustomersCursored', cursor?: string | null, items?: Array<{ __typename?: 'Customer', id?: string | null, value?: string | null, label?: string | null }> | null } | null };

export type getBusinessManagerOptionsForFilterQueryVariables = Exact<{
  filters?: InputMaybe<ExternalAdvertiserFilters>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type getBusinessManagerOptionsForFilterQuery = { __typename?: 'Query', entities?: { __typename?: 'ExternalAdvertisersCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdvertiser', id?: string | null, value?: string | null, label?: string | null }> | null } | null };

export type checkIfItCanEditFundsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type checkIfItCanEditFundsQuery = { __typename?: 'Query', externalAdAccounts?: { __typename?: 'ExternalAdAccountsCursored', items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null } | null> | null } | null };

export type InvoiceGroupsFieldsFragment = { __typename?: 'ExtendedCreditInvoiceGroup', extendedCreditInvoiceGroupName?: string | null, extendedCreditInvoiceGroupId?: string | null, lastMonthSpend?: number | null, currentMonthSpend?: number | null, id?: string | null, value?: string | null, label?: string | null, currency?: string | null, currencyTag?: string | null, status?: string | null, type?: string | null, fundsLeft?: string | null, lifetimeSpend?: string | null, amountSpent?: string | null, spendCap?: string | null, spendCapRatio?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null };

export type ExternalAdAccountsFieldsFragment = { __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountCreditLimitType?: string | null, id?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, spendCapRatio?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, autoRebalancedSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, currentMonthSpend?: number | null, lastMonthSpend?: number | null, fundsLeft?: number | null };

export type getInvoiceGroupsQueryVariables = Exact<{
  filter?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
  chartFilter?: InputMaybe<StatisticsFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ExtendedCreditInvoiceGroupOrderBy> | ExtendedCreditInvoiceGroupOrderBy>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getInvoiceGroupsQuery = { __typename?: 'Query', gridItems?: { __typename?: 'ExtendedCreditInvoiceGroupsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExtendedCreditInvoiceGroup', extendedCreditInvoiceGroupName?: string | null, extendedCreditInvoiceGroupId?: string | null, lastMonthSpend?: number | null, currentMonthSpend?: number | null, id?: string | null, value?: string | null, label?: string | null, currency?: string | null, currencyTag?: string | null, status?: string | null, type?: string | null, fundsLeft?: string | null, lifetimeSpend?: string | null, amountSpent?: string | null, spendCap?: string | null, spendCapRatio?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, chartStats?: Array<{ __typename: 'Statistics', spend?: number | null, date?: string | null } | null> | null, availableFunds?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountFundsLeft?: number | null } | null> | null, prepaidSpend?: Array<{ __typename?: 'ExternalAdAccount', currentMonthSpend?: number | null } | null> | null } | null> | null } | null };

export type getExternalAdAccountsExcelQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getExternalAdAccountsExcelQuery = { __typename?: 'Query', gridItems?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountCreditLimitType?: string | null, id?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, spendCapRatio?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, autoRebalancedSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, currentMonthSpend?: number | null, lastMonthSpend?: number | null, fundsLeft?: number | null } | null> | null } | null };

export type getInvoiceGroupsExcelQueryVariables = Exact<{
  filter?: InputMaybe<ExtendedCreditInvoiceGroupFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ExtendedCreditInvoiceGroupOrderBy> | ExtendedCreditInvoiceGroupOrderBy>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getInvoiceGroupsExcelQuery = { __typename?: 'Query', gridItems?: { __typename?: 'ExtendedCreditInvoiceGroupsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExtendedCreditInvoiceGroup', extendedCreditInvoiceGroupName?: string | null, extendedCreditInvoiceGroupId?: string | null, lastMonthSpend?: number | null, currentMonthSpend?: number | null, id?: string | null, value?: string | null, label?: string | null, currency?: string | null, currencyTag?: string | null, status?: string | null, type?: string | null, fundsLeft?: string | null, lifetimeSpend?: string | null, amountSpent?: string | null, spendCap?: string | null, spendCapRatio?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, externalAdAccounts?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountCreditLimitType?: string | null, id?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, spendCapRatio?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, autoRebalancedSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, currentMonthSpend?: number | null, lastMonthSpend?: number | null, fundsLeft?: number | null } | null> | null } | null> | null } | null };

export type getExternalAdAccountsQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAdAccountFilter>;
  chartFilter?: InputMaybe<StatisticsFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type getExternalAdAccountsQuery = { __typename?: 'Query', gridItems?: { __typename?: 'ExternalAdAccountsCursored', cursor?: string | null, items?: Array<{ __typename?: 'ExternalAdAccount', externalAdAccountId?: string | null, externalAdAccountName?: string | null, externalAdAccountStatus?: ExternalAdAccountStatus | null, externalAdvertiserId?: string | null, externalAdvertiserName?: string | null, extendedCreditInvoiceGroupId?: string | null, extendedCreditInvoiceGroupName?: string | null, externalAdAccountCreditLimitType?: string | null, id?: string | null, value?: string | null, label?: string | null, status?: ExternalAdAccountStatus | null, type?: string | null, currency?: FacebookCurrency | null, currencyTag?: FacebookCurrency | null, amountSpent?: number | null, lifetimeSpend?: number | null, spendCap?: number | null, spendCapRatio?: number | null, minSpendCap?: number | null, maxSpendCap?: number | null, spendFactor?: number | null, fundingSourceId?: string | null, adAccountSpendCapLimit?: number | null, defaultSpendCapLimit?: number | null, spendCapLimitTransaction?: number | null, autoRebalancedSpendCapLimit?: number | null, invoiceGroupSpendCapLimit?: number | null, invoiceGroupDefaultSpendCapLimit?: number | null, invoiceGroupSpendCapLimitTransaction?: number | null, currentMonthSpend?: number | null, lastMonthSpend?: number | null, fundsLeft?: number | null, chartStats?: Array<{ __typename: 'Statistics', spend?: number | null, date?: string | null } | null> | null } | null> | null } | null };

export type customersDataQueryVariables = Exact<{
  filters: CustomerFilters;
}>;


export type customersDataQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersCursored', items?: Array<{ __typename?: 'Customer', businessCurrencyTag?: string | null, billingTaxPercentage?: number | null, customerId?: string | null, customerCompanyName?: string | null, customerIsActivated?: number | null, customerIsFullyRegistered?: number | null, customerIsDeleted?: number | null, customerRegNumber?: string | null, customerVatNumber?: string | null, customerAccountType?: CustomerAccountType | null, customerEmail?: string | null, customerPhone?: string | null, customerAddress?: string | null, customerZip?: string | null, customerCity?: string | null, customerCountryName?: string | null, customerName?: string | null, customerSurname?: string | null, customerFullName?: string | null, customerLocalAddress?: string | null, customerLocalZip?: string | null, customerLocalCity?: string | null, customerLocalCountry?: string | null, customerLocalName?: string | null, customerLocalSurname?: string | null, customerLocalCompanyName?: string | null, businessFinanceEmail?: string | null, businessName?: string | null, bankName?: string | null, bankId?: string | null, bankCurrency?: string | null, bankAccountNumber?: string | null, bankType?: string | null, id?: string | null, value?: string | null, label?: string | null, businessManagerId?: string | null }> | null } | null };

export const ExternalAdAccountsBalanceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalAdAccountsBalanceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeft"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountSpendCap"}}]}}]} as unknown as DocumentNode<ExternalAdAccountsBalanceFieldsFragment, unknown>;
export const CustomerFundsLeftFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerFundsLeftFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeftActive"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeftClosed"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeftDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeftTotal"}},{"kind":"Field","name":{"kind":"Name","value":"customerAvailableFunds"}}]}}]} as unknown as DocumentNode<CustomerFundsLeftFieldsFragment, unknown>;
export const InvoiceGroupsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceGroupsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyTag"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"lastMonthSpend"}},{"kind":"Field","name":{"kind":"Name","value":"currentMonthSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupAccountType"}},{"kind":"Field","alias":{"kind":"Name","value":"fundsLeft"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupFundsLeft"}},{"kind":"Field","alias":{"kind":"Name","value":"lifetimeSpend"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupLifetimeSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapRatio"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupSpendCapRatio"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupDefaultSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimitTransaction"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimitTransaction"}}]}}]} as unknown as DocumentNode<InvoiceGroupsFieldsFragment, unknown>;
export const ExternalAdAccountsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalAdAccountsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"externalAdAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyTag"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"lifetimeSpend"},"name":{"kind":"Name","value":"externalAdAccountLifetimeSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapRatio"},"name":{"kind":"Name","value":"externalAdAccountSpendCapRatio"}},{"kind":"Field","alias":{"kind":"Name","value":"minSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMinSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"maxSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMaxSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendFactor"},"name":{"kind":"Name","value":"externalAdAccountSpendFactor"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"fundingSourceId"},"name":{"kind":"Name","value":"externalAdAccountFundingSourceId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapLimitTransaction"},"name":{"kind":"Name","value":"externalAdAccountCreditLimitTransaction"}},{"kind":"Field","alias":{"kind":"Name","value":"autoRebalancedSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountAutoRebalancedCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupDefaultSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimitTransaction"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimitTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountCreditLimitType"}},{"kind":"Field","alias":{"kind":"Name","value":"currentMonthSpend"},"name":{"kind":"Name","value":"currentMonthSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"lastMonthSpend"},"name":{"kind":"Name","value":"lastMonthSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"fundsLeft"},"name":{"kind":"Name","value":"externalAdAccountFundsLeft"}}]}}]} as unknown as DocumentNode<ExternalAdAccountsFieldsFragment, unknown>;
export const updateExternalAdAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateExternalAdAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdAccountType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minSpendCap"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxSpendCap"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spendFactor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalAdAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountMinSpendCap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minSpendCap"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountMaxSpendCap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxSpendCap"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountSpendFactor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spendFactor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserName"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendFactor"},"name":{"kind":"Name","value":"externalAdAccountSpendFactor"}},{"kind":"Field","alias":{"kind":"Name","value":"minSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMinSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"maxSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMaxSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"externalAdAccountType"}}]}}]}}]} as unknown as DocumentNode<updateExternalAdAccountMutation, updateExternalAdAccountMutationVariables>;
export const getAdAccountsForCreditLimitModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsForCreditLimitModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountDefaultCreditLimit"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimit"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"currentMonthSpend"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getAdAccountsForCreditLimitModalQuery, getAdAccountsForCreditLimitModalQueryVariables>;
export const allImportSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allImportSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportSettingFilters"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportSettingFilters"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"groupSettings"},"name":{"kind":"Name","value":"importSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"groupId"},"name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingName"}},{"kind":"Field","name":{"kind":"Name","value":"settingValue"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"businessSettings"},"name":{"kind":"Name","value":"importSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingName"}},{"kind":"Field","name":{"kind":"Name","value":"settingValue"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"globalSettings"},"name":{"kind":"Name","value":"importSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"GLOBAL"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingName"}},{"kind":"Field","name":{"kind":"Name","value":"settingValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<allImportSettingsQuery, allImportSettingsQueryVariables>;
export const getInvoiceGroupOptionsForAsyncDropdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupOptionsForAsyncDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"businessId"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCurrency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getInvoiceGroupOptionsForAsyncDropdownQuery, getInvoiceGroupOptionsForAsyncDropdownQueryVariables>;
export const getInvoiceGroupOptionsForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupOptionsForFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"extendedCreditInvoiceGroupId NOT LIKE 'null'","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getInvoiceGroupOptionsForFilterQuery, getInvoiceGroupOptionsForFilterQueryVariables>;
export const getAdAccountsOptionsForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsOptionsForFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getAdAccountsOptionsForFilterQuery, getAdAccountsOptionsForFilterQueryVariables>;
export const getFbAdAccStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFbAdAccStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountsAggregated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountLifetimeSpend"}},{"kind":"Field","name":{"kind":"Name","value":"lastMonthSpend"}},{"kind":"Field","name":{"kind":"Name","value":"currentMonthSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeft"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeftAreUnlimited"}}]}}]}}]} as unknown as DocumentNode<getFbAdAccStatisticsQuery, getFbAdAccStatisticsQueryVariables>;
export const getCurrencyOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrencyOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currencies"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<getCurrencyOptionsQuery, getCurrencyOptionsQueryVariables>;
export const getSpendCapChangelogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSpendCapChangelog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAdAccountId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ad_account_update_spend_limit","block":false},{"kind":"StringValue","value":"ad_account_reset_spend_limit","block":false},{"kind":"StringValue","value":"ad_account_remove_spend_limit","block":false}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"eventTime"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorName"}},{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"applicationName"}},{"kind":"Field","name":{"kind":"Name","value":"eventTime"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"extraData"}}]}}]}}]}}]} as unknown as DocumentNode<getSpendCapChangelogQuery, getSpendCapChangelogQueryVariables>;
export const updateDepositDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDeposit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositAmount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositReferenceFinal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeposit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"depositId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositId"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositAmount"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositReferenceFinal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositReferenceFinal"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositDescription"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositStatus"}},{"kind":"Field","name":{"kind":"Name","value":"depositStatusTime"}},{"kind":"Field","name":{"kind":"Name","value":"depositReferenceYear"}},{"kind":"Field","name":{"kind":"Name","value":"depositReferenceFinal"}},{"kind":"Field","name":{"kind":"Name","value":"depositPaymentType"}},{"kind":"Field","name":{"kind":"Name","value":"depositTaxPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"depositEntryDate"}},{"kind":"Field","name":{"kind":"Name","value":"depositDescription"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"depositPaymentDueTime"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"depositModifierFullName"}}]}}]}}]} as unknown as DocumentNode<updateDepositMutation, updateDepositMutationVariables>;
export const getAdAccountOptionsForReportFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountOptionsForReportFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getAdAccountOptionsForReportFilterQuery, getAdAccountOptionsForReportFilterQueryVariables>;
export const updateAdminInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAdminInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fbEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAdminUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"adminUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserFbEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fbEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserLogin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserIsDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adminUserId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adminUserName"}},{"kind":"Field","alias":{"kind":"Name","value":"surname"},"name":{"kind":"Name","value":"adminUserSurname"}},{"kind":"Field","alias":{"kind":"Name","value":"email"},"name":{"kind":"Name","value":"adminUserEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"fbEmail"},"name":{"kind":"Name","value":"adminUserFbEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"login"},"name":{"kind":"Name","value":"adminUserLogin"}},{"kind":"Field","alias":{"kind":"Name","value":"hasAgreedToTerms"},"name":{"kind":"Name","value":"adminUserHasAgreedToTerms"}},{"kind":"Field","alias":{"kind":"Name","value":"isDeleted"},"name":{"kind":"Name","value":"adminUserIsDeleted"}},{"kind":"Field","alias":{"kind":"Name","value":"phone"},"name":{"kind":"Name","value":"adminUserPhone"}}]}}]}}]} as unknown as DocumentNode<updateAdminInfoMutation, updateAdminInfoMutationVariables>;
export const updateAdminPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAdminPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permittedAdvertisers"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermittedExternalAdvertiser"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAdminUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"adminUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"permittedExternalAdvertisers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permittedAdvertisers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adminUserId"}},{"kind":"Field","name":{"kind":"Name","value":"permittedExternalAdvertisers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}}]}}]}}]}}]} as unknown as DocumentNode<updateAdminPermissionsMutation, updateAdminPermissionsMutationVariables>;
export const updateAdminCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAdminCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAdminUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"adminUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserCredentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adminUserId"}},{"kind":"Field","alias":{"kind":"Name","value":"credentials"},"name":{"kind":"Name","value":"adminUserCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}}]}}]}}]} as unknown as DocumentNode<updateAdminCredentialsMutation, updateAdminCredentialsMutationVariables>;
export const createAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fbEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permittedAdvertisers"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermittedExternalAdvertiser"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdminUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"adminUserName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserFbEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fbEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserLogin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"permittedExternalAdvertisers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permittedAdvertisers"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserCredentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}},{"kind":"Argument","name":{"kind":"Name","value":"adminUserPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adminUserId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adminUserName"}},{"kind":"Field","alias":{"kind":"Name","value":"surname"},"name":{"kind":"Name","value":"adminUserSurname"}},{"kind":"Field","alias":{"kind":"Name","value":"email"},"name":{"kind":"Name","value":"adminUserEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"fbEmail"},"name":{"kind":"Name","value":"adminUserFbEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"login"},"name":{"kind":"Name","value":"adminUserLogin"}},{"kind":"Field","alias":{"kind":"Name","value":"credentials"},"name":{"kind":"Name","value":"adminUserCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hasAgreedToTerms"},"name":{"kind":"Name","value":"adminUserHasAgreedToTerms"}},{"kind":"Field","alias":{"kind":"Name","value":"isDeleted"},"name":{"kind":"Name","value":"adminUserIsDeleted"}},{"kind":"Field","alias":{"kind":"Name","value":"phone"},"name":{"kind":"Name","value":"adminUserPhone"}},{"kind":"Field","name":{"kind":"Name","value":"permittedExternalAdvertisers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}}]}}]}}]}}]} as unknown as DocumentNode<createAdminMutation, createAdminMutationVariables>;
export const getBMOptionsOnClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBMOptionsOnClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdvertiserFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"externalAdvertisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getBMOptionsOnClientsQuery, getBMOptionsOnClientsQueryVariables>;
export const getCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"countryId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<getCountriesQuery, getCountriesQueryVariables>;
export const getAllExternalAdAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllExternalAdAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<getAllExternalAdAccountsQuery, getAllExternalAdAccountsQueryVariables>;
export const getFbAdAccOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFbAdAccOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<getFbAdAccOptionsQuery, getFbAdAccOptionsQueryVariables>;
export const getFbAdAccFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFbAdAccFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<getFbAdAccFilterOptionsQuery, getFbAdAccFilterOptionsQueryVariables>;
export const getAdAccountsBalanceAdminDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsBalanceAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalAdAccountsBalanceFields"}}]}}]}}]}},...ExternalAdAccountsBalanceFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getAdAccountsBalanceAdminQuery, getAdAccountsBalanceAdminQueryVariables>;
export const getInvoiceGroupsBalanceDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupsBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupFundsLeft"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalAdAccountsBalanceFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"availableFunds"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAdAccountStatus"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeft"}}]}}]}}]}}]}},...ExternalAdAccountsBalanceFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getInvoiceGroupsBalanceQuery, getInvoiceGroupsBalanceQueryVariables>;
export const getFbAdAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFbAdAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"externalAdAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyTag"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"lifetimeSpend"},"name":{"kind":"Name","value":"externalAdAccountLifetimeSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"minSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMinSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"maxSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMaxSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendFactor"},"name":{"kind":"Name","value":"externalAdAccountSpendFactor"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"fundingSourceId"},"name":{"kind":"Name","value":"externalAdAccountFundingSourceId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"autoRebalancedSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountAutoRebalancedCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupDefaultSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapLimitTransaction"},"name":{"kind":"Name","value":"externalAdAccountCreditLimitTransaction"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimitTransaction"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimitTransaction"}}]}}]}}]}}]} as unknown as DocumentNode<getFbAdAccountsQuery, getFbAdAccountsQueryVariables>;
export const updateSpendCapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSpendCap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpendCapAction"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSpendCap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"fundsLeft"},"name":{"kind":"Name","value":"externalAdAccountFundsLeft"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}}]}}]}}]} as unknown as DocumentNode<updateSpendCapMutation, updateSpendCapMutationVariables>;
export const refreshExternalAdAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refreshExternalAdAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshExternalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}}]}}]}}]} as unknown as DocumentNode<refreshExternalAdAccountsMutation, refreshExternalAdAccountsMutationVariables>;
export const doneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"done"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCompanyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerSalesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerProfileImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalZip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCompanyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalVatNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerZip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCountryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerVatNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerRegNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerIsVatCommitted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerContractSigned"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fbUserEmails"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerContractSigned"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerContractSigned"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsFullyRegistered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerContractSigned"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsActivated"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"customerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCompanyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCompanyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerSalesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerSalesforceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerProfileImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerProfileImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalZip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalZip"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCountry"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCompanyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCompanyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalVatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalVatNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankLocalName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalName"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankLocalAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalAccountNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerZip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerZip"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCountryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCountryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankType"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerVatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerVatNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerRegNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerRegNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsVatCommitted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerIsVatCommitted"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAccountType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountType"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankName"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fbUserEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fbUserEmails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","name":{"kind":"Name","value":"customerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsFullyRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasEContract"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasValidEContract"}},{"kind":"Field","name":{"kind":"Name","value":"businessCurrencyTag"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountName"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}}]}}]}}]}}]} as unknown as DocumentNode<doneMutation, doneMutationVariables>;
export const updateCustomerProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCompanyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerSalesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerProfileImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerIsActivated"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerIsDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCompanyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCompanyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerSalesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerSalesforceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerProfileImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerProfileImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsActivated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerIsActivated"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerIsDeleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSalesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bankType"}},{"kind":"Field","name":{"kind":"Name","value":"customerProfileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileImageEncoded"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageMimeType"}},{"kind":"Field","alias":{"kind":"Name","value":"file"},"name":{"kind":"Name","value":"profileImageEncoded"}}]}}]}}]}}]} as unknown as DocumentNode<updateCustomerProfileMutation, updateCustomerProfileMutationVariables>;
export const updateCustomerLocalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerLocal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalZip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCompanyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalVatNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalZip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalZip"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCountry"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalCompanyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalCompanyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerLocalVatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerLocalVatNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankLocalName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalName"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankLocalAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankLocalAccountNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalVatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankLocalName"}},{"kind":"Field","name":{"kind":"Name","value":"bankLocalAccountNumber"}}]}}]}}]} as unknown as DocumentNode<updateCustomerLocalMutation, updateCustomerLocalMutationVariables>;
export const updateCustomerContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerZip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerCountryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCity"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerZip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerZip"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerCountryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerCountryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerCountryId"}},{"kind":"Field","name":{"kind":"Name","value":"customerCountryName"}}]}}]}}]} as unknown as DocumentNode<updateCustomerContactMutation, updateCustomerContactMutationVariables>;
export const updateCustomerAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerVatNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerRegNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerIsVatCommitted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerVatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerVatNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerRegNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerRegNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIsVatCommitted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerIsVatCommitted"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAccountType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountType"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerVatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerRegNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsVatCommitted"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}}]}}]} as unknown as DocumentNode<updateCustomerAccountMutation, updateCustomerAccountMutationVariables>;
export const updateCustomerExternalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerExternal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalAdAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdAccountIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountName"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"businessManagerId"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}}]}}]}}]} as unknown as DocumentNode<updateCustomerExternalMutation, updateCustomerExternalMutationVariables>;
export const updateCustomerAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomerAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fbUserEmails"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fbUserEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fbUserEmails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}}]}}]} as unknown as DocumentNode<updateCustomerAccessMutation, updateCustomerAccessMutationVariables>;
export const segmentFallbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"segmentFallback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}}]}}]} as unknown as DocumentNode<segmentFallbackMutation, segmentFallbackMutationVariables>;
export const getCustomerDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSalesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerProfileImageId"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerCountryId"}},{"kind":"Field","name":{"kind":"Name","value":"customerCountryName"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsFullyRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasEContract"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasValidEContract"}},{"kind":"Field","name":{"kind":"Name","value":"customerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerVatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerRegNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsVatCommitted"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"bankType"}},{"kind":"Field","name":{"kind":"Name","value":"bankCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","alias":{"kind":"Name","value":"businessManagerId"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalVatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerContractSigned"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsFullyRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"bankLocalName"}},{"kind":"Field","name":{"kind":"Name","value":"bankLocalAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerProfileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileImageEncoded"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageMimeType"}},{"kind":"Field","alias":{"kind":"Name","value":"file"},"name":{"kind":"Name","value":"profileImageEncoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}}]}}]}}]} as unknown as DocumentNode<getCustomerDataQuery, getCustomerDataQueryVariables>;
export const getCustomersFundsLeftDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomersFundsLeft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerFundsLeftFields"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasUnlimitedSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountName"},"name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountStatus"}}]}}]}}]}}]}},...CustomerFundsLeftFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getCustomersFundsLeftQuery, getCustomersFundsLeftQueryVariables>;
export const getCustomersForGridDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomersForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsFullyRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasEContract"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasValidEContract"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bankCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"customerStatus"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerFundsLeftFields"}},{"kind":"Field","name":{"kind":"Name","value":"customerHasUnlimitedSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"businessCurrencyTag"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountName"},"name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},...CustomerFundsLeftFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getCustomersForGridQuery, getCustomersForGridQueryVariables>;
export const depositsCursoredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"depositsCursored"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepositFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepositFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterExclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"depositId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositStatus"}},{"kind":"Field","name":{"kind":"Name","value":"depositStatusTime"}},{"kind":"Field","name":{"kind":"Name","value":"depositReferenceYear"}},{"kind":"Field","name":{"kind":"Name","value":"depositReferenceFinal"}},{"kind":"Field","name":{"kind":"Name","value":"depositPaymentType"}},{"kind":"Field","name":{"kind":"Name","value":"depositTaxPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"depositEntryDate"}},{"kind":"Field","name":{"kind":"Name","value":"depositDescription"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"depositPaymentDueTime"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSurname"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"depositModifierFullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<depositsCursoredQuery, depositsCursoredQueryVariables>;
export const getAdAccountsForMoveFundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsForMoveFunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterExclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyTag"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"fundsLeft"},"name":{"kind":"Name","value":"externalAdAccountFundsLeft"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getAdAccountsForMoveFundsQuery, getAdAccountsForMoveFundsQueryVariables>;
export const getAdAccountsBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeft"}}]}}]}}]}}]} as unknown as DocumentNode<getAdAccountsBalanceQuery, getAdAccountsBalanceQueryVariables>;
export const getStatisticsForChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticsForChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"inlineLinkClicks"}},{"kind":"Field","name":{"kind":"Name","value":"outboundClicks"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","alias":{"kind":"Name","value":"amount"},"name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"socialSpend"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseRoas"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppPurchaseRoas"}},{"kind":"Field","name":{"kind":"Name","value":"inlinePostEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"conversions"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"canvasAvgViewTime"}},{"kind":"Field","name":{"kind":"Name","value":"canvasAvgViewPercent"}},{"kind":"Field","name":{"kind":"Name","value":"videoAverageTimeWatched"}},{"kind":"Field","name":{"kind":"Name","value":"videoComplete"}},{"kind":"Field","name":{"kind":"Name","value":"videoP25Watched"}},{"kind":"Field","name":{"kind":"Name","value":"videoP50Watched"}},{"kind":"Field","name":{"kind":"Name","value":"videoP75Watched"}},{"kind":"Field","name":{"kind":"Name","value":"videoP95Watched"}},{"kind":"Field","name":{"kind":"Name","value":"videoP100Watched"}},{"kind":"Field","name":{"kind":"Name","value":"video10SecWatched"}},{"kind":"Field","name":{"kind":"Name","value":"video30SecWatched"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"websiteClickRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"actionRate"}},{"kind":"Field","name":{"kind":"Name","value":"cpm"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"cpwc"}},{"kind":"Field","name":{"kind":"Name","value":"cpcv"}},{"kind":"Field","name":{"kind":"Name","value":"cpa"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<getStatisticsForChartQuery, getStatisticsForChartQueryVariables>;
export const getStatisticsForStatBarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticsForStatBar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"conversions"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<getStatisticsForStatBarQuery, getStatisticsForStatBarQueryVariables>;
export const getClientStatisticsForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientStatisticsForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"inlineLinkClicks"}},{"kind":"Field","name":{"kind":"Name","value":"outboundClicks"}},{"kind":"Field","name":{"kind":"Name","value":"conversions"}},{"kind":"Field","name":{"kind":"Name","value":"inlinePostEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"cpa"}},{"kind":"Field","name":{"kind":"Name","value":"cpcv"}},{"kind":"Field","name":{"kind":"Name","value":"cpm"}},{"kind":"Field","name":{"kind":"Name","value":"cpwc"}},{"kind":"Field","name":{"kind":"Name","value":"mobileAppPurchaseRoas"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseRoas"}},{"kind":"Field","name":{"kind":"Name","value":"actionRate"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","alias":{"kind":"Name","value":"amount"},"name":{"kind":"Name","value":"spend"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getClientStatisticsForGridQuery, getClientStatisticsForGridQueryVariables>;
export const getAdAccountsForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdAccountsForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gridItems"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"externalAdAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertiserName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"currencyTag"},"name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"amountSpent"},"name":{"kind":"Name","value":"externalAdAccountAmountSpent"}},{"kind":"Field","alias":{"kind":"Name","value":"lifetimeSpend"},"name":{"kind":"Name","value":"externalAdAccountLifetimeSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCap"},"name":{"kind":"Name","value":"externalAdAccountSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapRatio"},"name":{"kind":"Name","value":"externalAdAccountSpendCapRatio"}},{"kind":"Field","alias":{"kind":"Name","value":"minSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMinSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"maxSpendCap"},"name":{"kind":"Name","value":"externalAdAccountMaxSpendCap"}},{"kind":"Field","alias":{"kind":"Name","value":"spendFactor"},"name":{"kind":"Name","value":"externalAdAccountSpendFactor"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCreditInvoiceGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"fundingSourceId"},"name":{"kind":"Name","value":"externalAdAccountFundingSourceId"}},{"kind":"Field","alias":{"kind":"Name","value":"adAccountSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"spendCapLimitTransaction"},"name":{"kind":"Name","value":"externalAdAccountCreditLimitTransaction"}},{"kind":"Field","alias":{"kind":"Name","value":"autoRebalancedSpendCapLimit"},"name":{"kind":"Name","value":"externalAdAccountAutoRebalancedCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupDefaultSpendCapLimit"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupDefaultCreditLimit"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceGroupSpendCapLimitTransaction"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroupCreditLimitTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountCreditLimitType"}},{"kind":"Field","alias":{"kind":"Name","value":"currentMonthSpend"},"name":{"kind":"Name","value":"currentMonthSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"lastMonthSpend"},"name":{"kind":"Name","value":"lastMonthSpend"}},{"kind":"Field","alias":{"kind":"Name","value":"fundsLeft"},"name":{"kind":"Name","value":"externalAdAccountFundsLeft"}},{"kind":"Field","alias":{"kind":"Name","value":"chartStats"},"name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getAdAccountsForGridQuery, getAdAccountsForGridQueryVariables>;
export const getPaymentInstructionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPaymentInstructions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"walletPaymentInstructions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"depositId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<getPaymentInstructionsQuery, getPaymentInstructionsQueryVariables>;
export const GetTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionExternalFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionsExternal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"transactionExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionExternalTransactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionExternalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSurname"}},{"kind":"Field","name":{"kind":"Name","value":"transactionExternalEntryDate"}},{"kind":"Field","name":{"kind":"Name","value":"businessCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"transactionExternalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"modifierFullName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountTransactionAmount"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountTransactionStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const createWalletDepositDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWalletDeposit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeposit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bankId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankId"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"depositPaymentType"},"value":{"kind":"EnumValue","value":"ADVANCE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"depositId"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceNumber"}}]}}]}}]} as unknown as DocumentNode<createWalletDepositMutation, createWalletDepositMutationVariables>;
export const ExternalAdAccountOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalAdAccountOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterExclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterExclude"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<ExternalAdAccountOptionsQuery, ExternalAdAccountOptionsQueryVariables>;
export const getClientOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilters"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"customerFullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getClientOptionsQuery, getClientOptionsQueryVariables>;
export const getBusinessManagerOptionsForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBusinessManagerOptionsForFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdvertiserFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"externalAdvertisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"externalAdvertiserName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<getBusinessManagerOptionsForFilterQuery, getBusinessManagerOptionsForFilterQueryVariables>;
export const checkIfItCanEditFundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkIfItCanEditFunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountId"}}]}}]}}]}}]} as unknown as DocumentNode<checkIfItCanEditFundsQuery, checkIfItCanEditFundsQueryVariables>;
export const getInvoiceGroupsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gridItems"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceGroupsFields"}},{"kind":"Field","alias":{"kind":"Name","value":"chartStats"},"name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"availableFunds"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAdAccountStatus"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalAdAccountFundsLeft"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"prepaidSpend"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAdAccountType"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PREPAID"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMonthSpend"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},...InvoiceGroupsFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getInvoiceGroupsQuery, getInvoiceGroupsQueryVariables>;
export const getExternalAdAccountsExcelDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExternalAdAccountsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gridItems"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalAdAccountsFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},...ExternalAdAccountsFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getExternalAdAccountsExcelQuery, getExternalAdAccountsExcelQueryVariables>;
export const getInvoiceGroupsExcelDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendedCreditInvoiceGroupOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gridItems"},"name":{"kind":"Name","value":"extendedCreditInvoiceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceGroupsFields"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalAdAccountsFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},...InvoiceGroupsFieldsFragmentDoc.definitions,...ExternalAdAccountsFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getInvoiceGroupsExcelQuery, getInvoiceGroupsExcelQueryVariables>;
export const getExternalAdAccountsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExternalAdAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalAdAccountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gridItems"},"name":{"kind":"Name","value":"externalAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalAdAccountsFields"}},{"kind":"Field","alias":{"kind":"Name","value":"chartStats"},"name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},...ExternalAdAccountsFieldsFragmentDoc.definitions]} as unknown as DocumentNode<getExternalAdAccountsQuery, getExternalAdAccountsQueryVariables>;
export const customersDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customersData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilters"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"customerId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","alias":{"kind":"Name","value":"businessManagerId"},"name":{"kind":"Name","value":"externalAdvertiserId"}},{"kind":"Field","name":{"kind":"Name","value":"businessCurrencyTag"}},{"kind":"Field","name":{"kind":"Name","value":"billingTaxPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsFullyRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"customerIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"customerRegNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerVatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerAccountType"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerCountryName"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalZip"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCity"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalName"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalSurname"}},{"kind":"Field","name":{"kind":"Name","value":"customerLocalCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessFinanceEmail"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"bankId"}},{"kind":"Field","name":{"kind":"Name","value":"bankCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankType"}}]}}]}}]}}]} as unknown as DocumentNode<customersDataQuery, customersDataQueryVariables>;